var formatDate = new Intl.DateTimeFormat("it-IT").format;
var formatCurrency = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format;
let strongPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,15}$/;
let strongPasswordAccount = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,100}$/;
let _lcid;
let _cc;
let _restriction = Array();
let autocompleteShip;
let addressField;
let zipField;
let placeship;

DevExpress.localization.locale(navigator.language);

var IsUserPlus = function () {
    var elem = document.getElementById('hIsUserPlus');
    if (elem && elem.value) {
        return (/true/).test(elem.value.toLowerCase());
    }
    else {
        return false;
    }
}
var IsUserLogged = function () {
    var elem = document.getElementById('hIsUserLogged');
    if (elem && elem.value) {
        return (/true/).test(elem.value.toLowerCase());
    }
    else {
        return false;
    }
}

const Costanti = {
    ESITO_OK: 'ok',
    ESITO_OK_ORDINE: 'okOrdine',
    ESITO_KO: 'ko',
    NOTIFY_COLOR_SUCCESS: 'success',
    NOTIFY_COLOR_ERROR: 'error',
    NOTIFY_COLOR_DANGER: 'danger',
    NOTIFY_COLOR_WARNING: 'warning',
    STATO_ORDINE_RIPETITIVO: 42,
    STATO_ORDINE_POSTICIPATO: 43,
    STATO_ORDINE_POSTICIPATO_ATTIVO: 44,
    STATO_ORDINE_RIPETITIVO_APPROVAZIONE1: 45,
    STATO_ORDINE_RIPETITIVO_APPROVAZIONE2: 46,
    STATO_ORDINE_POSTICIPATO_APPROVAZIONE1: 47,
    STATO_ORDINE_POSTICIPATO_APPROVAZIONE2: 48,
    TIPO_SPEDIZIONE_VELOCE: 1,
    TIPO_SPEDIZIONE_LENTA: 2
}

function dateformat(v) {
    if (v === null || v === 'undefined') {
        return '';
    }
    else {
        try {
            if (typeof v === 'string' || v instanceof String) {
                v = new Date(v);
            }
            let date, month, year;

            date = v.getDate();
            month = v.getMonth() + 1;
            year = v.getFullYear();

            date = date
                .toString()
                .padStart(2, '0');

            month = month
                .toString()
                .padStart(2, '0');

            return `${date}/${month}/${year}`;
        } catch (error) {
            return '';
        }

    }
    //return formatDate(new Date(v));
}

function dateToDateTime(v) {
    if (v === null || v === 'undefined') {
        return '';
    }
    else {
        try {
            if (typeof v === 'string' || v instanceof String) {
                v = new Date(v);
            }
            let date, month, year;

            date = v.getDate();
            month = v.getMonth() + 1;
            year = v.getFullYear();

            date = date
                .toString()
                .padStart(2, '0');

            month = month
                .toString()
                .padStart(2, '0');

            return `${month}/${date}/${year}`;
        } catch (error) {
            return '';
        }

    }
}

function addDays(date, number) {
    var newDate = new Date(date);
    return new Date(newDate.setDate(date.getDate() + parseInt(number)));
}

function addMonths(date, months) {
    let result = new Date(date);
    result.setMonth(result.getMonth() + date.getDate() + parseInt(months));
    return result;
}

function addYears(date, years) {
    let result = new Date(date);
    result.setFullYear(result.getFullYear() + date.getDate() + parseInt(years));
    return result;
}

function getDaysInMonth(date) {
    let year = date.getFullYear();
    let month = date.getMonth();

    // Imposta la data sul primo giorno del mese successivo e sottrai un giorno
    let nextMonth = new Date(year, month + 1, 1);
    nextMonth.setDate(nextMonth.getDate() - 1);

    // Restituisci il giorno, che è l'ultimo giorno del mese originale
    return nextMonth.getDate();
}

function DisabilitaWeekend() {
    try {
        $("td.dx-calendar-cell[aria-label *= 'sabato']").css('background-color', 'lightgray').click(function () {
            return false;
        });
        $("td.dx-calendar-cell[aria-label *= 'domenica']").css('background-color', 'lightgray').click(function () {
            return false;
        });
    } catch (error) {
        console.log(error);
    }
}


//$(document).ready(function () {
//    DataGridSettings();
//});

function DataGridSettings() {
    $('.dx-datagrid').each(function (index, item) {
        try {
            var element = $(item).parent();

            if (element && element.length > 0) {
                var grid = element.dxDataGrid('instance');

                grid.option('noDataText', mainController.GetLabel('lNessunRisultato'));
                grid.option('loadPanel').text = mainController.GetLabel('lMessaggioCaricamento');
                grid.option('filterRow').showOperationChooser = false;
                grid.option('paging').pageSize = 15;
                grid.option('pager').visible = true;
                grid.option('pager').showNavigationButtons = true;
                grid.option('pager').showInfo = true;
                grid.option('pager').infoText = mainController.GetLabel('lPagerGrigliaDefault');
                grid.option('onContextMenuPreparing', function (e) {
                    console.log(e);
                    if (e.target === 'header' || e.target === 'headerPanel') {
                        e.items = null;
                    }
                });
                //console.log(grid.option());
            }
        }
        catch (error) {
            console.log(error);
        }
    });
}

/**
 * Permette di visualizzare la password tramite l'occhiolino
 * @param {any} element l'elemento dell'icona dell'occhio
 * @param {any} divId L'id del campo input con 'type=password'
 */
function ViewPassword(element, divId) {
    if ($('#' + divId).prop('type') == 'password') {
        $('#' + divId).prop('type', 'text');
    }
    else {
        $('#' + divId).prop('type', 'password');
    }

    if (element.innerHTML == 'visibility') {
        element.innerHTML = 'visibility_off';
    }
    else {
        element.innerHTML = 'visibility';
    }

    if (element.style.webkitUserSelect == '') {
        element.style.webkitUserSelect = 'none';
    }
}
$(document).ready(function () {
    checkidcart();
    InizializzaTooltipBootstrap();
});

function InizializzaTooltipBootstrap() {
    try {
        var tooltipTriggerList = [].slice.call(
            document.querySelectorAll('[data-bs-toggle="tooltip"]')
        );
        if (tooltipTriggerList.length > 0) {
            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl);
            });
        }
    }
    catch (error) {
        console.log(error);
    }
}

function checkidcart() {
    mainController.CallServiceAsync('/HandleIdBasketTemp')
        .then(risp => {
            var expires = new Date();
            var days = 3600 * 1000 * 24 * 365;
            expires.setTime(expires.getTime() + (days));
            var c = getCookie(risp.esito);
            if (!c) {
                document.cookie = risp.esito + "=" + risp.responseText + ";expires=" + expires + "; path=/";
            }
        })
        .catch(error => {
            console.log(error);
            waitingBS.Hide();
        });
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


/**
* COMMON
* */
var commonController = (function () {

    function ControllaSoloNumeri(element) {
        var val = element.value;
        val = val.replace(/[^\d\+]/g, '');
        $('#' + element.id).val(val);
    }

    function ChangePassword(Token, Email) {

        var password = $('#rec-password')
        var cpassword = $('#rec-cpassword')
        var chkpassword = $('#chkpassword')

        if (CheckPassword(password, cpassword, chkpassword) == true) {

            var params = {
                lr: {
                    token: Token,
                    password: password.val(),
                    email: Email
                },
                isFromForcedReset: false
            };
            waitingBS.Show();
            mainController.CallServiceAsync('/Account/ResetPassword', params)
                .then(risp => {
                    if (risp.esito == Costanti.ESITO_OK) {
                        mainController.NotifyMessage(risp.responseText, risp.NotifyColor);

                        setTimeout(function () {
                            window.location.href = risp.ReturnUrl;
                        }, 3000);
                    }
                    else {
                        mainController.NotifyMessage(risp.responseText, risp.NotifyColor);
                        waitingBS.Hide();
                    }
                })
                .catch(error => {
                    console.log(error);
                    waitingBS.Hide();
                });
        }

        return false;
    }


    var onloadCallback = function (key, language) {

        if (!key) {
            console.log('grecaptcha key non impostata');
        }
        else {
            grecaptcha.render('google_captcha', {
                'sitekey': key,
                'callback': verifyCallback,
                'hl': language
            });
        }
    };

    function verifyCallback(gresponse) {

        var params = {
            response: gresponse
        };

        var buttonSubmit = $('#fcontatti button[type="submit"]')[0];

        if (!buttonSubmit) {
            buttonSubmit = $('#fresetpassword button[type="submit"]')[0];
        }

        if (!buttonSubmit) {
            buttonSubmit = $('#fverificaemail button[type="submit"]')[0];
        }

        if (!buttonSubmit) {
            buttonSubmit = $('#flavoraconnoi button[type="submit"]')[0];
        }

        if (!buttonSubmit) {
            buttonSubmit = $('#fregistrazione button[type="submit"]#btnRegister')[0];
        }

        if (buttonSubmit) {
            mainController.CallServiceAsync('/Home/CheckRecaptchaResponse', params)
                .then(result => {
                    if (result && result.esito == Costanti.ESITO_OK) {
                        $('#CheckGuid').val(result.responseText);
                        buttonSubmit.disabled = false;
                        setTimeout(() => {
                            buttonSubmit.disabled = true;
                        }, 60000); //dopo 1 minuto disabilito il bottone dato che la validità del captcha è di 1 minuto
                    }
                    else {
                        buttonSubmit.disabled = true;
                        console.log(result?.responseText);
                    }
                })
                .catch(error => {
                    console.log(error);
                    buttonSubmit.disabled = true;
                });

        }
    }

    function ResetPasswordLoginUser() {
        $('#fresetpassword').submit(function (e) {
            try {
                waitingBS.Show();
                var inputemail = $("#reset-email");
                var email = inputemail.val();
                if (email?.trim()) {
                    if (mainController.CheckEmail(email) == true) {
                        var param = {};
                        param.email = email;
                        mainController.CallServiceAsync('/checkUserAccountExists', param)
                            .then(risp => {
                                if (risp == true) {
                                    var formData = new FormData(this);
                                    mainController.CallServiceFormDataAsync($('#fresetpassword').attr('action'), formData)
                                        .then(r => {
                                            waitingBS.Hide();
                                            if (r.esito == Costanti.ESITO_OK) {
                                                mainController.NotifyMessage(r.responseText, r.NotifyColor);
                                            }
                                            else {
                                                mainController.NotifyMessage(r.responseText, r.NotifyColor);
                                            }
                                        })
                                        .catch(error => {
                                            console.log('Error action: ' + error);
                                            waitingBS.Hide();
                                        });
                                }
                                else {
                                    inputemail.addClass('is-invalid');
                                    mainController.NotifyMessage(mainController.GetLabel('lemailnonvalida'), 'error')
                                    waitingBS.Hide();
                                }
                            })
                    }
                    else {
                        inputemail.addClass('is-invalid');
                        mainController.NotifyMessage(mainController.GetLabel('revEmail'), 'error');
                        waitingBS.Hide();
                    }
                }
                else {
                    inputemail.addClass('is-invalid');
                    waitingBS.Hide();
                }
            }
            catch (error) {
                console.log('Error try: ' + error);
                waitingBS.Hide();
            }
            e.preventDefault();
        });
    }

    function ResetPasswordLoginAccount() {
        $('#fresetpassword').submit(function (e) {
            if (CheckAccountExistsStart('username', 'emailacc') == true) {
                waitingBS.Show();
                var formData = new FormData(this);

                $.ajax({
                    url: $('#fresetpassword').attr('action'),
                    type: "POST",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: formData,
                    contentType: false,
                    processData: false,
                    success: function (r) {
                        mainController.NotifyMessageTimed(r.responseText, r.NotifyColor, 5000);
                        waitingBS.Hide();
                    },
                    error: function (r) {
                        mainController.NotifyMessage(r.responseText, r.NotifyColor);
                        waitingBS.Hide();
                    }
                });
            }
            e.preventDefault();
        });
    }



    return {
        "ControllaSoloNumeri": ControllaSoloNumeri,
        "ChangePassword": ChangePassword,
        "onloadCallback": onloadCallback,
        "ResetPasswordLoginUser": ResetPasswordLoginUser,
        "ResetPasswordLoginAccount": ResetPasswordLoginAccount
    }
})();

/**
 * Controller principale per gestire le funzionalità comuni del javascript.
 * */
var mainController = (function () {

    /**
     * Traccia un evento select_item su GA ed effettua il redirect all'url indicato nei parametri.
     * @param {string} s codice prodotto.
     * @param {string} n nome prodotto.
     * @param {string} c categoria prodotto.
     * @param {string} m marca prodotto.
     * @param {number} pr prezzo prodotto.
     * @param {string} url url di destinazione.
     * @param {string} l lista di prelievo.
     * @param {string} cur currency.
     * @param {string} e nome evento.
     * @param {string} area Il nome dell'area creatività promozionale associata all'evento.
     * @param {string} idpr L'ID della promozione associato all'evento.
     * @param {string} npr Il nome della promozione associato all'evento.
     * @param {number} x L'indice/la posizione dell'elemento in un elenco.
     * @param {number} d Indica il valore dello sconto generato dalla promozione
     * @param {1} mouseClick Indica quale click del mouse è stato effettuato (1 = sinistro, 2 = centrale, 3 = destro)
     */
    function ClickCard(s, n, c, m, pr, url, l, cur, e, area, idpr, npr, x, d, mouseClick) {
        if (mouseClick === 3) {
            //tasto destro
            //capire se si vuole registrale l'azione del tasto destro
        }
        else {
            if (typeof dataLayer !== "undefined") {
                var p = {};
                p.id = s;
                p.name = n;
                p.category = c;
                p.brand = m;
                p.price = parseFloat(pr);
                p.variant = "";
                p.quantity = 1;
                p.listname = l;
                p.coupon = "";
                p.index = parseInt(x);

                if (e === "select_promotion") {
                    p.creative_slot = area;
                    p.promotion_id = idpr;
                    p.promotion_name = npr;
                    p.discount = d;
                }

                ga4.e_pushEvent(p, e, cur);
            }

            if (url !== "undefined" && url.length > 0) {
                if (mouseClick === 2) {
                    window.open(url, '_blank');
                }
                else {
                    window.location.href = url;
                }
            }
        }
    }

    /**
     * Traccia un evento view_item specifico per i prodotti in promozione su GA.
     * @param {string} s codice prodotto.
     * @param {string} n nome prodotto.
     * @param {string} c categoria prodotto.
     * @param {string} m marca prodotto.
     * @param {number} pr prezzo prodotto.
     * @param {string} l lista di prelievo.
     * @param {string} cur currency.
     * @param {string} e nome evento.
     * @param {string} area Il nome dell'area creatività promozionale associata all'evento.
     * @param {string} idpr L'ID della promozione associato all'evento.
     * @param {string} npr Il nome della promozione associato all'evento.
     * @param {number} x L'indice/la posizione dell'elemento in un elenco.
     * @param {number} d Indica il valore dello sconto generato dalla promozione
     */
    function ViewCard(s, n, c, m, pr, l, cur, e, area, idpr, npr, x, d) {
        if (typeof dataLayer !== "undefined") {
            var p = {};
            p.id = s;
            p.name = n;
            p.category = c;
            p.brand = m;
            p.price = parseFloat(pr);
            p.variant = "";
            p.quantity = 1;
            p.listname = l;
            p.coupon = "";
            p.index = parseInt(x);
            p.creative_slot = area;
            p.promotion_id = idpr;
            p.promotion_name = npr;
            p.discount = d;

            ga4.e_pushEvent(p, e, cur);
        }
    }

    /**
     * 
     * @param {string} cn nome del file immagine visualizzato
     * @param {string} cs area della promozione associata all'evento
     * @param {string} id id della promozione
     * @param {string} pn nome della promozione
     * @param {string} sku codice prodotto
     * @param {string} name nome prodotto
     * @param {number} index indice sulla lista di prelievo
     * @param {string} cat ultimo livello di catagoria
     * @param {string} brand marca del prodotto
     * @param {string} ln nome della lista di prelievo
     * @param {number} price prezzo promozione
     * @param {number} q quantità prodotto
     */
    function ViewPromotion(cn, cs, id, pn, sku, name, index, cat, brand, ln, price, q) {
        if (typeof dataLayer !== "undefined") {
            var p = {};
            p.id = sku;
            p.name = name;
            p.category = cat;
            p.brand = brand;
            p.price = parseFloat(price);
            p.variant = "";
            p.quantity = parseInt(q);
            p.listname = ln;
            p.coupon = "";
            p.index = parseInt(index);
            p.creative_name = cn
            p.creative_slot = cs;
            p.promotion_id = id;
            p.promotion_name = pn;

            ga4.e_pushEvent(p, 'view_promotion', cur);
        }
    }

    /**
     * 
     * @returns
     */
    function getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.replace('#', '').slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    function ChangeLanguage(l) {
        waitingBS.Show();
        var p = {};
        p.lcid = l;

        CallServicePromise("/Home/SelectLanguage", p)
            .then(function (r) {
                if (r.esito == Costanti.ESITO_OK) {
                    setTimeout(function () {
                        window.location.href = r.ReturnUrl;
                    }, 1000);
                }
                else {
                    waitingBS.Hide();
                    mainController.NotifyMessage(r.responseText, r.NotifyColor);
                }
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
                mainController.NotifyMessage(r.responseText, r.NotifyColor);
            });
    }


    /**
     * Ritorna una stringa che rappresenta il valore di un etichetta corrispondente all'id.
     * @param {string} id
     */
    function GetLabel(id) {
        var r = CallService('/GetLabelJs', id.toString());
        return r;
    }

    function RefreshCartGrid(pos, idindirizzo) {
        $.ajax({
            url: '/GetCartGrid',
            data: { posizione: pos, idind: idindirizzo },
            success: function (data) {
                $("#cartgrid").html(data);
            }
        })
    }

    function RefreshHeaderCart() {
        $.get("/GetHeaderCart", function (data) {
            $("#headercart").html(data);
        });
    }

    function RefreshHeaderWishlist() {
        $.get("/GetHeaderWishList", function (data) {
            $("#headerwishlist").html(data);
        });
    }


    /**
     * Effettua il refresh del componente che visualizza il menu di un utente loggato.
     * */
    function RefreshMenu() {
        $.get("/GetHeader", function (data) {
            $("#menulogged").html(data);
        });
    }

    /**
     * Effettua il refresh del componente che visualizza i totali del carrello.
     * @param {number} id
     * @param {string} buonoSconto
     * @param {boolean} hide
     * @param {string} giftcard
     * @param {number} tipopagamento
     */
    function RefreshTotali(id, buonoSconto, hide, giftcard, tipopagamento) {

        if (id == null || id == undefined || id == 0) {
            var indirizzo = $("#idsped").val();
            if (indirizzo != null && indirizzo != undefined) {
                id = indirizzo;
            }
        }

        if (buonoSconto == null || buonoSconto == undefined || buonoSconto == '') {
            var bs = $("#buonosconto").val();
            if (bs != null && bs != undefined) {
                buonoSconto = bs;
            }
        }

        if (giftcard == null || giftcard == undefined || giftcard == '') {
            var gf = $('#giftcard').val();
            if (gf != null && gf != undefined) {
                giftcard = gf;
            }
        }

        if (tipopagamento == null || tipopagamento == undefined || tipopagamento == 0) {
            var tp = $('#paytype').val();
            if (tp != null && tp != undefined) {
                tipopagamento = tp;
            }
        }

        var dettSpedizione = {
            IsConsegnaPianoApp: false,
            IsConsegnaSabato: false,
            IsConsegnaSabatoApp: false,
            IsCosegnaSera: false,
            IsConsegnaPiano: false,
            ConsegnaProgrammata: false,

            TipoSpedizione: 0,
            CostoConsegnaProgrammata: 0,
            CostoConsegnaPiano: 0,
            CostoConsegnaPianoApp: 0,
            CostoConsegnaSabato: 0,
            CostoCosegnaSera: 0,
            CostoConsegnaSabatoApp: 0
        };

        var dettagliSpedizione = $('#shippingType');
        if (dettagliSpedizione != null && dettagliSpedizione != undefined) {
            if (dettagliSpedizione.val() != null && dettagliSpedizione.val() != undefined && dettagliSpedizione.val() != '') {

                switch (dettagliSpedizione.val()) {
                    case 'IsConsegnaPianoApp':
                        dettSpedizione.IsConsegnaPianoApp = true;
                        break;
                    case 'IsConsegnaSabato':
                        dettSpedizione.IsConsegnaSabato = true;
                        break;
                    case 'IsConsegnaSabatoApp':
                        dettSpedizione.IsConsegnaSabatoApp = true;
                        break;
                    case 'IsCosegnaSera':
                        dettSpedizione.IsCosegnaSera = true;
                        break;
                    case 'IsConsegnaPiano':
                        dettSpedizione.IsConsegnaPiano = true;
                        break;
                    case 'ConsegnaProgrammata':
                        dettSpedizione.ConsegnaProgrammata = true;
                        break;
                    case 'ConsegnaExpress':
                        dettSpedizione.TipoSpedizione = '1';
                        break;
                    case 'ConsegnaStandard':
                        dettSpedizione.TipoSpedizione = '2';
                        break;
                    default:
                        break;
                }
            }
        }
        var tiposped = $('#tipospedizione');
        if (tiposped != null && tiposped != undefined) {
            dettSpedizione.TipoSpedizione = tiposped.val();
        }

        $.ajax({
            url: '/GetTotaliBasket',
            type: "POST",
            data: { idindirizzo: id, buonosconto: buonoSconto, giftcard: giftcard, dettaglispedizione: JSON.stringify(dettSpedizione), idtipopagamento: tipopagamento },
            success: function (data) {
                $("#totalibasket").html(data);
                if (hide) {
                    var panel = $('#LoadPanelCartGrid');
                    if (panel.length > 0) {
                        panel.dxLoadPanel('instance').option('visible', false);
                    }
                    waitingBS.Hide();
                }
            },
            error: function (xhr, status, error) {
                console.log(error);
                console.log(status);
                console.log(xhr);
                if (hide) {
                    waitingBS.Hide();
                }
            }
        });
    }

    function RefreshCartOffCanvas() {
        var div = $('#kioskoffcanvas');
        if (div && div.length > 0) {
            $.get("/GetCartOffCanvas", function (data) {
                $("#kioskoffcanvas").html(data);
            });
        }
    }

    function RefreshCartFooterBadge() {
        var div = $('#kioskbadge');
        if (div && div.length > 0) {
            $.get("/GetCartFooterBadge", function (data) {
                $("#kioskbadge").html(data);
            });
        }
    }

    function ScrollToTop() {
        $(window).scrollTop(0);
    }

    /**
     * [Deprecated]
     * Chiama un servizio api o un controller locale
     * Usare la funzione CallServiceData
     * @deprecated
     * @param {string} c_url - indirizzo del servizio da chiamare
     * @param {object} values - oggetto con i parametri previsti dal servizio
     */
    function CallService(c_url, values) {
        var r = null;

        /* Il metodo che utilizza questo servizio DEVE avere la variabile che si chiama 'value' */
        var params = {
            value: values
        };

        $.ajax({
            url: c_url,
            data: params,
            type: "POST",
            async: false,
            success: function (result) {
                r = result;
            },
            error: function (xhr, status, error) {
                console.log(xhr);
                console.log(status);
                console.log(error);
            }
        });
        return r;
    }

    function CallServiceDataInner(c_url, params) {
        var r = null;

        $.ajax({
            url: c_url,
            data: params,
            type: "POST",
            async: false,
            success: function (result) {
                r = result;
            },
            error: function (xhr, status, error) {
                console.log(xhr);
                console.log(status);
                console.log(error);
            }
        });
        return r;
    }


    /**
     * Chiama un servizio api o un controller locale utilizzando come parametro data i campi letti da un form attraverso l'oggetto FormData.
     * @param {string} c_url - indirizzo del servizio da chiamare
     * @param {object} params - oggetto con i parametri previsti dal servizio
     */
    function CallServiceFormData(c_url, params) {
        let r = null;
        $.ajax({
            url: c_url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: params,
            contentType: false,
            processData: false,
            async: false,
            success: function (result) {
                r = result;
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr);
                console.log(ajaxOptions);
                console.log(thrownError);
            }
        });

        return r;
    }
    function CallServiceFormDataPromise(c_url, params) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: c_url,
                type: "POST",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: params,
                contentType: false,
                processData: false,
                success: function (result) {
                    resolve(result);
                },
                error: function (xhr, status, error) {
                    reject(error);
                }
            });
        });
    }

    /**
     * Chiama un servizio api o un controller locale in modalità async
     * @param {any} c_url - indirizzo del servizio da chiamare
     * @param {any} params - oggetto con i parametri previsti dal servizio
     * @returns
     */
    function CallServicePromise(c_url, params) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: c_url,
                data: params,
                type: "POST",
                dataType: "json",
                success: function (result) {
                    resolve(result);
                },
                error: function (xhr, status, error) {
                    reject(error);
                }
            });
        });
    }

    /**
     * Chiama un servizio api o un controller locale in modalità async per ritornare un html
     * @param {any} c_url
     * @param {any} params
     * @returns
     */
    function CallServiceHtmlAsync(c_url, params) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: c_url,
                data: params,
                contentType: 'text/html',
                success: function (result) {
                    resolve(result);
                },
                error: function (xhr, status, error) {
                    reject(error);
                }
            });
        });
    }

    /**
     * Visualizza una notifica a monitor attraverso il componente di DevExpress.
     * @param {string} text - testo da visualizzare nella notifica
     * @param {string} color - colore da utilizzare per la notifica secondo la nomenclatura di Bootstrap (success, error, danger, ecc.)
     */
    function Notify(text, color) {
        try {
            var n = $("#toast").dxToast("instance");

            if (n != null && n != undefined) {
                $("#toast").dxToast("instance").option({
                    type: color,
                    message: decodeHTMLEntity(text),
                    visible: true,
                    displayTime: 5000,
                    width: '90vw',
                    animation: {
                        show: {
                            type: 'fade', duration: 400, from: 0, to: 1,
                        },
                        hide: { type: 'fade', duration: 40, to: 0 },
                    },
                });
            }


        }
        catch (error) {
            console.log(error);
        }
    }

    /**
     * Visualizza una notifica a monitor attraverso il componente di DevExpress.
     * @param {string} txt - testo da visualizzare nella notifica
     * @param {string} color - colore da utilizzare per la notifica secondo la nomenclatura di Bootstrap (success, error, danger, ecc.)
     * @param {number} time - il tempo (in millisecondi) che il popup si deve vedere
     */
    function NotifyTime(txt, color, time) {
        var n = $("#toast").dxToast("instance");
        if (n != null && n != undefined) {
            $("#toast").dxToast("instance").option({
                type: color,
                message: decodeHTMLEntity(txt),
                visible: true,
                displayTime: time,
                width: '90vw',
                animation: {
                    show: {
                        type: 'fade', duration: 400, from: 0, to: 1,
                    },
                    hide: { type: 'fade', duration: 40, to: 0 },
                },
            });
        }
    }
    function decodeHTMLEntity(encodedString) {
        var tempElement = document.createElement("div");
        tempElement.innerHTML = encodedString;
        return tempElement.textContent || tempElement.innerText;
    }
    /**
     * Verifica correttezza di un codice fiscale italiano
     * @param {string} cf - il codice fiscale da verificare
     * */
    function CheckCodiceFiscale(cf) {
        if (!cf) {
            return false;
        }
        else {
            var c = cf.toUpperCase();
            if (CodiceFiscale.check(c) == false) {
                return false;
            }
            else {
                return true;
            }
        }
    }

    function CostruisciSlider(idSlider, isLoopId, numId) {
        var isloop = false;
        var num = 5;

        try {
            var inpisloop = document.getElementById(isLoopId);
            if (inpisloop != null)
                isloop = inpisloop.value == "true";
        } catch (e) {
            console.log(e);
        }

        try {
            var inpnum = document.getElementById(numId);
            if (inpnum != null)
                num = inpnum.value;
        } catch (e) {
            console.log(e);
        }
        var responsive = undefined;
        if (idSlider.includes('Alternative')) {
            responsive = {
                0: {
                    items: 1,
                    nav: true
                },
                650: {
                    items: 2,
                    nav: true
                },
                1050: {
                    items: 3,
                    nav: true
                },
                1400: {
                    items: 4,
                    nav: true
                },
                1750: {
                    items: 5,
                    nav: true
                },
                2000: {
                    items: 6,
                    nav: true
                }
            }
        }
        if (idSlider.includes('lCarrelloDSConsiglia')) {
            responsive = {
                0: {
                    items: 1,
                    nav: true
                },
                400: {
                    items: 2,
                    nav: true
                },
                800: {
                    items: 3,
                    nav: true
                },
                1000: {
                    items: 3,
                    nav: true
                },
                1100: {
                    items: 4,
                    nav: true
                },
                1400: {
                    items: 5,
                    nav: true
                },
                1750: {
                    items: 6,
                    nav: true
                },
            }
        }
        else if (idSlider.includes('Post')) {
            responsive = {
                0: {
                    items: 2,
                    nav: true
                },
                460: {
                    items: 3,
                    nav: true
                },
                767: {
                    items: 1,
                    nav: true
                },
                1050: {
                    items: 2,
                    nav: true
                }
            }
        }

        mainController.InizializzaSlider(isloop, idSlider, num, responsive);

        setTimeout(() => {
            var maxheight = 0;

            for (var i = 0; i < $("#" + idSlider + " .item.card-item").length; i++) {
                if ($("#" + idSlider + " .item.card-item")[i].offsetHeight > maxheight) {
                    maxheight = $("#" + idSlider + " .item.card-item")[i].offsetHeight;
                }
            }

            for (var i = 0; i < $("#" + idSlider + " .item.card-item").length; i++) {
                $("#" + idSlider + " .item.card-item")[i].style = "height: " + maxheight + "px";
            }
        }, 500);
    }

    /**
 * Inizializza uno slider di prodotti
 * @param {boolean} isloop Determina se loopare lo slider
 * @param {string} classeid classe css del div slider
 * @param {int} num Il numero di prodotti da visualizzare
 */
    function InizializzaSlider(isloop, classeid, num, obj, margine) {

        var navigation = num > 4;
        if (isloop == false && navigation === false) {
            isloop = false;
        }
        var owl = $("." + classeid);

        if (!obj) {
            obj = {
                0: {
                    items: 1,
                    nav: true
                },
                600: {
                    items: 3,
                    nav: true
                },
                850: {
                    items: 4,
                    nav: true
                },
                1100: {
                    items: 5,
                    nav: true
                },
                1350: {
                    items: 6,
                    nav: true
                },
                1600: {
                    items: 7,
                    nav: true
                },
                1850: {
                    items: 7,
                    nav: true
                },
                2100: {
                    items: 7,
                    nav: true
                },
                2350: {
                    items: 7,
                    nav: true
                }
            }
        }

        if (!margine) {
            margine = 10;
        }

        owl.owlCarousel({
            loop: isloop,
            margin: margine,
            nav: navigation,
            dots: false,
            responsive: obj,
            navElement: 'div'
        })
    };
    function InizializzaSliderBanner(isloop, classeid, num) {

        var navigation = Boolean(num <= 4);
        if (navigation === false) {
            isloop = false;
        }
        var owl = $("." + classeid);
        owl.owlCarousel({
            loop: isloop,
            margin: 0,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 1,
                    nav: true
                },
                600: {
                    items: 2,
                    nav: true
                },
                850: {
                    items: 2,
                    nav: true
                },
                1100: {
                    items: 3,
                    nav: true
                },
                1350: {
                    items: 3,
                    nav: true
                },
                1600: {
                    items: 4,
                    nav: true
                },
                1850: {
                    items: 4,
                    nav: true
                },
                2100: {
                    items: 4,
                    nav: true
                },
                2350: {
                    items: 4,
                    nav: true
                }
            },
            navElement: 'div'
        })
    };

    $(document).ready(function () {
        var inslider = $(".owl-stage");
        inslider.addClass("row");
    });

    function CheckPIVA(pi) {

        if (pi === '') {
            return 'lErrorePIVAZero';
        }
        if (! /^[0-9]{11}$/.test(pi)) {
            return 'lErroreLunghezzaPIVA';
        }
        else if (pi === '00000000000') {
            return 'lErrorePIVANonValido';
        }
        else {
            var s3 = 0;
            for (i = 0; i <= 9; i += 2)
                s3 += pi.charCodeAt(i) - '0'.charCodeAt(0);
            for (var i = 1; i <= 9; i += 2) {
                var c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
                if (c > 9) c = c - 9;
                s3 += c;
            }
            var atteso = (10 - s3 % 10) % 10;
            if (atteso !== pi.charCodeAt(10) - '0'.charCodeAt(0)) {
                return 'lErrorePIVANonValido';
            }
            else {
                return '';
            }
        }
    }

    /**
     * Controlla se un indirizzo email è formalmente corretto.
     * @param {any} email
     */
    function is_email(email) {
        if (email != null && email != undefined && email != '') {
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
            return emailReg.test(email);
        }

        return false;
    }

    /**
     * Imposta il default button 'button' ad una textbox 'input'
     * @param {string} input
     * @param {string} button
     */
    function setDefaultButton(input, button) {
        document.getElementById("" + input).addEventListener(
            "keyup",
            (e) => {
                if (e.key === "Enter") {
                    document.getElementById("" + button).click()
                }
            });
    }

    function ScaricaDocumentoOrdine(IdDocumento) {
        try {
            window.open('/Utility/DownloadDocumentoOrdine?IdDoc=' + IdDocumento, '_blank', 'name = provapippo');
        }
        catch (error) {
            console.log(error);
        }
        finally {
            return false;
        }
    }

    function ScaricaDocumentoAllegatoOrdine(IdDocumento) {
        try {
            window.open('/Utility/DownloadAllegatiOrdine?IdDoc=' + IdDocumento, '_blank', 'name = provapippo');
        }
        catch (error) {
            console.log(error);
        }
        finally {
            return false;
        }
    }

    function ScegliSpecialita() {
        $('#hSpecialita').val('');
        var a = $('#listspecialita').dxList('instance').option('selectedItemKeys');
        for (let i = 0; i < a.length; i++) {
            $('#hSpecialita').val($('#hSpecialita').val() + ',' + a[i]);
        }
    }

    function GetSliderProdotti(chiave, idds, idElement) {

        $.ajax({
            url: '/GetSliderProdotti',
            data: { Key: chiave, Value: idds },
            success: function (data) {
                $("#" + idElement).html(data);
            }
        });
    }

    function VerificaDisponibilitaProdotto(IDDS) {
        try {

            if (IDDS && IDDS.length > 0) {

                var params = {
                    idds: IDDS
                };

                return mainController.CallServiceData('/Prodotti/VerificaDisponibilitaProdotto', params);
            }

        } catch (err) {
            console.log(err);
            return false;
        }
    }

    /**
     * Effettua una chiamata ajax per verificare l'univocità della partita iva passata.
     * @param {any} partitaIva
     * @param {any} cf
     * @param {any} gruppoIva
     * @returns
     */
    function CheckUnivocitaPartitaIva(partitaIva, cf, gruppoIva) {
        try {

            if (partitaIva && partitaIva.length > 0) {

                var params = {
                    PIva: partitaIva,
                    CodFiscale: cf,
                    GruppoIva: gruppoIva
                };

                var r = mainController.CallServiceData('/Utility/CheckUnivocitaPartitaIva', params);

                if (r == true) {
                    return '';
                }
                else {
                    if (gruppoIva == true) {
                        return 'lGruppoIvaEsistente';
                    }
                    else {
                        return 'lPartitaIVAUsata';
                    }
                }
            }

        } catch (err) {
            console.log(err);
            return 'lPartitaIVAUsata';
        }
    }


    return {
        "CallServiceAsync": CallServicePromise,
        "CallServiceFormData": CallServiceFormData,
        "CallServiceFormDataAsync": CallServiceFormDataPromise,
        "CallService": CallService,
        "CallServiceData": CallServiceDataInner,
        "NotifyMessage": Notify,
        "NotifyMessageTimed": NotifyTime,
        "CheckCodiceFiscale": CheckCodiceFiscale,
        "CheckPartitaIva": CheckPIVA,
        "CheckEmail": is_email,
        "ScrollToTop": ScrollToTop,
        "RefreshMenu": RefreshMenu,
        "RefreshTotali": RefreshTotali,
        "RefreshHeaderCart": RefreshHeaderCart,
        "RefreshHeaderWishlist": RefreshHeaderWishlist,
        "RefreshDettaglioCarrello": RefreshCartGrid,
        "GetLabel": GetLabel,
        "RefreshCartFooterBadge": RefreshCartFooterBadge,
        "RefreshCartOffCanvas": RefreshCartOffCanvas,
        "InizializzaSlider": InizializzaSlider,
        "CostruisciSlider": CostruisciSlider,
        "InizializzaSliderBanner": InizializzaSliderBanner,
        "getUrlVars": getUrlVars,
        "ChangeLanguage": ChangeLanguage,
        "SetDefaultButton": setDefaultButton,
        "ScaricaDocumentoOrdine": ScaricaDocumentoOrdine,
        "ScaricaDocumentoAllegatoOrdine": ScaricaDocumentoAllegatoOrdine,
        "ScegliSpecialita": ScegliSpecialita,
        "decodeHTMLEntity": decodeHTMLEntity,
        "GetSliderProdotti": GetSliderProdotti,
        "ClickCard": ClickCard,
        "ViewCard": ViewCard,
        "ViewPromotion": ViewPromotion,
        "VerificaDisponibilitaProdotto": VerificaDisponibilitaProdotto,
        "CheckUnivocitaPartitaIva": CheckUnivocitaPartitaIva,
        "CallServiceHtmlAsync": CallServiceHtmlAsync
    }
})();

/**
 * CHECKOUT
 * */
var checkoutController = (function () {
    function RegisterOrder(stato) {
        waitingBS.Show();

        var GFriepilogo = $('#riepilogoGiftCard');
        var GFtotali = $('#hgiftcard').val();

        if (!GFriepilogo.val()) {
            GFriepilogo.val(GFtotali);
        }
        if (stato != null && stato > 0 && stato != undefined) {
            $('#hstato').val(stato);
        }

        return true;
    }

    function AccountAddCart(i, q, c) {
        waitingBS.Show();
        var p = {};
        p.idds = i;
        p.qta = q;
        p.cdi = c;

        mainController.CallServiceAsync("/Checkout/AccountAddCart", p)
            .then(function (r) {
                if (r.esito == Costanti.ESITO_OK) {

                    try {
                        if (typeof dataLayer !== "undefined" && r.JsonObject) {
                            eval('var product=' + r.JsonObject);
                            ga4.e_pushEvent(product, r.GA4EventExt, r.Valuta);

                            var cb2 = document.cookie.replace(/(?:(?:^|.*;\s*)cbadv\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                            if (r.IdSito == 1 && cb2 && cb2 == "1" && typeof window.pushEvent === "function") {
                                //ga4.pushEvent(product, 'addToCart', r.Valuta);
                            }
                        }
                    } catch (e) {

                    }
                }

                waitingBS.Hide();
                mainController.NotifyMessage(r.responseText, r.NotifyColor);
                mainController.RefreshHeaderCart();
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
            });
    }

    /**
     * Aggiunge un prodotto al carrello
     * @param {string} i - codice idds del prodotto
     * @param {int} q - quantità
     * @param {int} c - centro di costo
     * @param {string} s - sorgente dell'action
     * */
    function AddCart(i, q, c, s) {
        waitingBS.Show();
        var p = {};
        p.idds = i;
        p.qta = q;
        p.cdc = c;
        p.source = s;

        mainController.CallServiceAsync("/Checkout/AddCart", p)
            .then(function (r) {
                if (r.esito == Costanti.ESITO_OK) {
                    try {
                        // Issue #1440: dati utente al dataLayer, presenti solo se loggato (Claude)
                        if (typeof dataLayer !== "undefined" && r.LeadsUserData) {
                            ga4.e_pushLeadsUserData(r.LeadsUserData);
                        }

                        if (typeof dataLayer !== "undefined" && r.JsonObject) {
                            eval('var product=' + r.JsonObject);
                            ga4.e_pushEvent(product, r.GA4EventExt, r.Valuta);

                            if (r.Sorgente === "accessori") {
                                mainController.ClickCard(product.id, product.name, product.category, product.brand, product.price, '', r.Sorgente, 'EUR', 'selezione_accessorio');
                            }

                            var cb2 = document.cookie.replace(/(?:(?:^|.*;\s*)cbadv\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                            if (r.IdSito == 1 && cb2 && cb2 == "1" && typeof window.pushEvent === "function") {
                                //ga4.pushEvent(product, 'addToCart', r.Valuta);
                            }
                        }
                        if (r.ReturnUrl != '' && s != 'wishlist') {
                            window.location.href = r.ReturnUrl;
                        }
                        else {
                            mainController.NotifyMessage(r.responseText, r.NotifyColor);
                            mainController.RefreshHeaderCart();
                            mainController.RefreshCartOffCanvas();
                            mainController.RefreshCartFooterBadge();
                            mainController.RefreshDettaglioCarrello();
                            waitingBS.Hide();
                        }

                    } catch (e) {
                        console.log(e);
                        waitingBS.Hide();
                    }
                }
                else {
                    mainController.NotifyMessage(r.responseText, r.NotifyColor);
                    waitingBS.Hide();
                }
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
            });
    }

    /**
     * 
     * @param {any} idds - codice IDDS del prodotto
     * @param {any} aid - Account Id
     * @param {any} ido - Id Ordine
     * @param {any} idu - id User
     */
    function AccountDeleteOrderRow(idds, ido) {
        waitingBS.Show();
        var p = {};
        p.idds = idds;
        p.ido = ido;

        mainController.CallServiceAsync("/Checkout/AccountDeleteOrderRow", p)
            .then(function (r) {
                waitingBS.Hide();
                mainController.NotifyMessage(r.responseText, r.NotifyColor);

                if (r.esito == Costanti.ESITO_OK) {
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
                mainController.NotifyMessage("ERROR", "danger");
            });
    }

    /**
   * Aggiorna un prodotto a carrello.
   * @param {string} IDDS - codice idds del prodotto
   * @param {int} quantita - quantità
   * @param {int} cdc - centro di costo
   * @param {string} azione - action da intraprendere: Add/Remove
   * @param {string} pos - posizione del pulsante: Carrello(basket)/Ordine
   * @param {int} indirizzo - L'id dell'indirizzo di spedizione
   * */
    function AccountUpdateCart(IDDS, quantita, cdc, azione, pos, indirizzo) {
        var gridInstance = $("#gridContainer").dxDataGrid("instance");
        waitingBS.Show();
        var p = {};
        p.idds = IDDS;
        p.qta = quantita;
        p.cdi = cdc;
        p.fn = azione;
        p.posizione = pos;

        mainController.CallServiceAsync("/Checkout/AccountUpdateCart", p)
            .then(function (r) {
                try {
                    try {
                        if (r.esito == Costanti.ESITO_OK) {
                            mainController.RefreshDettaglioCarrello(pos, indirizzo);
                            mainController.RefreshMenu();
                            mainController.RefreshHeaderCart();
                            //mainController.RefreshTotali(indirizzo); 
                            if (typeof dataLayer !== "undefined" && r.JsonObject) {
                                eval('var product=' + r.JsonObject);
                                ga4.e_pushEvent(product, r.GA4EventExt, r.Valuta);
                            }
                        }
                        else if (r.esito == Costanti.ESITO_OK_ORDINE) {
                            location.reload();
                        }
                    } catch (err) {
                        console.log(err);
                    }
                    if (typeof gridInstance !== "undefined") {
                        gridInstance.refresh();
                    }
                    mainController.NotifyMessageTimed(r.responseText, r.NotifyColor, 4000);
                }
                finally {
                    setTimeout(function () {
                        waitingBS.Hide();
                    }, 1000);
                }
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
                mainController.NotifyMessage("ERROR", "danger");
            });
    }

    /**
   * Aggiorna un prodotto a carrello.
   * @param {string} IDDS - codice idds del prodotto
   * @param {int} quantita - quantità
   * @param {int} cdc - centro di costo
   * @param {string} azione - action da intraprendere: Add/Remove
   * @param {string} pos - posizione del pulsante: Carrello(basket)/Ordine
   * @param {string} source - sorgente dell'action: input/button
   * */
    function UpdateCart(IDDS, quantita, cdc, azione, pos, source, isFromSlider) {
        var posizione = pos;

        if (source == 'button')
            posizione = 'prodotto';

        var gridInstance = $("#gridContainer").dxDataGrid("instance");

        var panel = $('#LoadPanelCartGrid');
        if (panel.length > 0) {
            panel.dxLoadPanel('instance').option('visible', true);
        }
        else {
            if (!gridInstance) {
                waitingBS.Show();
            }
        }

        var p = {};
        p.idds = IDDS;
        p.qta = quantita;
        p.cdcID = cdc;
        p.fn = azione;
        p.posizione = posizione;

        mainController.CallServiceAsync("/Checkout/UpdateCart", p)
            .then(function (r) {
                if (r.esito == Costanti.ESITO_OK) {
                    try {
                        if (typeof dataLayer !== "undefined" && r.JsonObject) {
                            eval('var product=' + r.JsonObject);
                            ga4.e_pushEvent(product, r.GA4EventExt, r.Valuta);
                        }
                    }
                    catch (e) {
                        console.log(e);
                    }
                }

                if (typeof gridInstance !== "undefined") {
                    gridInstance.refresh();
                }
                var bs = $("#hbuonosconto");
                var buonoSconto = '';
                if (bs != null && bs != undefined && bs != '') {
                    buonoSconto = bs.val();
                }
                var gc = $("#hgiftcard");
                var giftcard = '';
                if (gc != null && gc != undefined && gc != '') {
                    giftcard = gc.val();
                }
                if (r.IsCarrelloVuoto == false) {
                    mainController.RefreshDettaglioCarrello(pos);
                    mainController.RefreshMenu();
                    mainController.RefreshHeaderCart();
                    mainController.RefreshCartOffCanvas();
                    mainController.RefreshCartFooterBadge();
                    mainController.RefreshTotali(null, buonoSconto, true, giftcard);
                    if ((panel.length == 0 && !gridInstance) || isFromSlider) {
                        mainController.NotifyMessage(r.responseText, r.NotifyColor);
                    }
                }
                else {
                    window.location.reload();
                }
            })
            .catch(function (error) {
                console.log(error);
                var panel = $('#LoadPanelCartGrid');
                if (panel.length > 0) {
                    panel.dxLoadPanel('instance').option('visible', false);
                }
                else {
                    var gridInstance = $("#gridContainer").dxDataGrid("instance");
                    if (!gridInstance) {
                        waitingBS.Show();
                    }
                }
                mainController.NotifyMessage("ERROR", "danger");
            });
    }

    /**
     * Svuota il carrello.
     * */
    function AccountEmptyCart() {
        waitingBS.Show();
        mainController.CallServiceAsync("/Checkout/AccountEmptyCart")
            .then(function (r) {
                waitingBS.Hide();

                if (r.esito == "true") {
                    var gridInstance = $("#gridContainer").dxDataGrid("instance");
                    gridInstance.refresh();
                }

                mainController.RefreshDettaglioCarrello();
                mainController.RefreshTotali();
                mainController.RefreshMenu();
                mainController.RefreshHeaderCart();
                mainController.NotifyMessage(r.responseText, r.success);
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
                mainController.NotifyMessage("ERROR", "danger");
            });
    }

    /**
     * Svuota il carrello.
     * */
    function EmptyCart() {
        waitingBS.Show();
        mainController.CallServiceAsync("/Checkout/EmptyCart")
            .then(function (r) {
                mainController.NotifyMessage(r.responseText, r.success);
                if (r.esito == Costanti.ESITO_OK) {
                    //var gridInstance = $("#gridContainer").dxDataGrid("instance");
                    //gridInstance.refresh();
                    window.location.reload();
                }

                //mainController.RefreshDettaglioCarrello();
                //mainController.RefreshMenu();
                //mainController.RefreshHeaderCart();
                //waitingBS.Hide();
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
                mainController.NotifyMessage("ERROR", "danger");
            });
    }

    function GetShippingCost(id) {
        waitingBS.Show();
        var p = {};
        p.idindirizzo = id;

        mainController.CallServiceAsync("/Checkout/GetSpeseSpedizione", p)
            .then(function (r) {
                var bs = $("#hbuonosconto");
                var buonoSconto = '';
                if (bs != null && bs != undefined && bs != '') {
                    buonoSconto = bs.val();
                }
                var gc = $("#hgiftcard");
                var giftcard = '';
                if (gc != null && gc != undefined && gc != '') {
                    giftcard = gc.val();
                }
                mainController.RefreshTotali(id, buonoSconto, false, giftcard);
                waitingBS.Hide();
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
                mainController.NotifyMessage("ERROR", "danger");
            });
    }

    function CheckFinaleOrdine(cellulare, telefono, nome, cognome, nomecognome) {
        try {
            var tipoPagamento = $('#TipologiePagamento').dxRadioGroup('instance').option('value');
            if (tipoPagamento == null || tipoPagamento == undefined || tipoPagamento == '') {
                mainController.NotifyMessageTimed(mainController.GetLabel('rfvPagamento'), Costanti.NOTIFY_COLOR_ERROR, 3500);
                return false;
            }
            else if (tipoPagamento == 23) {
                var rate = $('#rblRenting').dxRadioGroup('instance').option('value');
                if (rate == null || rate == undefined || rate == '') {
                    mainController.NotifyMessageTimed('Per proseguire, è necessario indicare la rateizzazione!', Costanti.NOTIFY_COLOR_ERROR, 3500);
                    return false;
                }
            }
            else if (tipoPagamento == 63) {
                var rate = $('#rblIfis').dxRadioGroup('instance').option('value');
                if (rate == null || rate == undefined || rate == '') {
                    mainController.NotifyMessageTimed('Per proseguire, è necessario indicare la rateizzazione!', Costanti.NOTIFY_COLOR_ERROR, 3500);
                    return false;
                }
            }
            else if (tipoPagamento == 10) {
                var rate = $('#rblFinanziamento').dxRadioGroup('instance').option('value');
                if (rate == null || rate == undefined || rate == '') {
                    mainController.NotifyMessageTimed('Per proseguire, è necessario indicare la modalità di rateizzazione!', Costanti.NOTIFY_COLOR_ERROR, 3500);
                    return false;
                }
            }
            else if (tipoPagamento == 62) {
                var cell = $('#cellulare').val();
                if (cell == null || cell == undefined || cell == '') {
                    mainController.NotifyMessageTimed(mainController.GetLabel('MBWay_TelefonoObbligatorio'), Costanti.NOTIFY_COLOR_ERROR, 3500);
                    return false;
                }
            }

            var ListaDiRadioGroup = $('div [id^="rg"]');
            var indexVuoti = 0;
            $.each(ListaDiRadioGroup, function (index, value) {
                var rbgElem = $('#' + value.id);
                if (rbgElem && rbgElem.length > 0) {
                    try {
                        var rbgInstance = rbgElem.dxRadioGroup('instance');

                        if (!rbgInstance.option('value')) {
                            indexVuoti++;
                        }
                    }
                    catch (e) {
                        console.log(value.id + ' is not a dxRadioGroup');
                        console.log(e);
                    }
                }
            });

            if (indexVuoti == ListaDiRadioGroup.length) {
                return false;
            }
        }
        catch (error) {
            console.log(error);
            return false;
        }

        try {
            if (((cellulare || telefono) && ((nome && cognome) || nomecognome))?.trim() == false) { //Controllo che il cliente abbia scelto un indirizzo di spedizione con almeno 1 dei due recapiti

                var bsPopup = document.getElementById('BSPopup');
                $('#BSPopup [id^=btnNascondiCheckout]').addClass('hidden'); // Nascondo il bottone per chiudere il checkout (non ci deve essere [va in conflitto])
                $('#TitleForm').html(mainController.GetLabel('lRecapitoNonValidoIndirizzo')); // Cambio il titolo del form di modifica dell'indirizzo
                var popup = new bootstrap.Modal(bsPopup); // Recupero l'oggetto popup di bootstrap
                popup.show()
                return false;
            }
        }
        catch (error) {
            console.log(error);
            return false;
        }
        return true;
    }

    /**
     * Controlla se i dati inseriti sono validi e in caso positivo ricarica i totali
     * @param {string} codicebs
     * @param {string} codicegc
     */
    function UsaCodiceSconto(codicebs, codicegc) {
        try {
            waitingBS.Show();

            var params = {
                buonosconto: codicebs,
                giftcard: codicegc
            }

            $.ajax({
                url: '/Checkout/UsaCodiciSconto',
                type: 'POST',
                data: params,
                success: function (result) {
                    try {
                        if (result.esito == Costanti.ESITO_OK) {
                            $('#hbuonosconto').val(codicebs);
                            $('#hFormBuonoSconto').val(codicebs);
                            $('#buonosconto').val(codicebs);
                            $('#hgiftcard').val(codicegc);
                            $('#hFormGiftCard').val(codicegc);
                            mainController.RefreshTotali(0, codicebs, true, codicegc);
                            return;
                        }
                        else {
                            mainController.NotifyMessageTimed(result.responseText, result.NotifyColor, 3500);
                            waitingBS.Hide();
                            return;
                        }
                    }
                    catch (error) {
                        console.log(error);
                        waitingBS.Hide();
                    }
                },
                error: function (xhr, status, error) {
                    console.log(error);
                    console.log(status);
                    console.log(xhr);
                    mainController.NotifyMessage('ERROR!', 'error')
                    waitingBS.Hide();
                }
            });
        }
        catch (error) {
            console.log(error);
            waitingBS.Hide();
        }
    }

    function AnnullaPrenotazioneGiftCard(giftcard) {
        try {
            var params = {
                giftcard: giftcard
            }

            $.ajax({
                url: '/Checkout/AnnullaPrenotazioneGiftCard',
                type: 'POST',
                data: params,
                success: function (result) {
                    try {
                        if (result.esito != Costanti.ESITO_OK) {
                            mainController.NotifyMessage(result.responseText, result.NotifyColor);
                            return;
                        }
                    }
                    catch (error) {
                        console.log(error);
                    }
                },
                error: function (xhr, status, error) {
                    console.log(error);
                    console.log(xhr);
                    mainController.NotifyMessage('ERROR!', 'error')
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    function ConcludiOrdineCarrello() {
        try {
            waitingBS.Show();

            var tbbuonosconto = $('#hbuonosconto');
            var codicebuono = '';

            if (tbbuonosconto != null && tbbuonosconto != undefined) {
                codicebuono = tbbuonosconto.val();
            }
            var tbgiftcard = $('#tbGiftCard');
            var codicecard = '';

            if (tbgiftcard != null && tbgiftcard != undefined) {
                codicecard = tbgiftcard.val();
            }

            var params = {
                buonosconto: codicebuono,
                giftcard: codicecard
            }

            $.ajax({
                url: '/Checkout/CheckoutSpedizione',
                type: 'POST',
                data: params,
                success: function (risp) {
                    $('html').html(risp);
                },
                error: function (xhr, status, error) {
                    console.log(error);
                    console.log(status);
                    console.log(xhr);
                    mainController.NotifyMessage('ERROR!', 'error')
                    waitingBS.Hide();
                }
            });
        }
        catch (error) {
            console.log(error);
            waitingBS.Hide();
        }
    }
    //Aggiunge una lista di prodotti al carrello
    //listIdds - lista di codice idds del prodotto
    //qta - quantità
    //cdc - centro di costo
    //localization - sorgente dell'action            
    function AddCartBulk(listIdds, qta, cdc, localization) {
        try {
            waitingBS.Show();
            var p = {
                listIdds: listIdds,
                qta: qta,
                cdc: cdc,
                localization: localization
            }

            $.ajax({
                url: '/Checkout/AddCartBulk',
                type: 'POST',
                data: p,
                success: function (result) {
                    try {
                        if (result.esito == Costanti.ESITO_OK) {
                            mainController.NotifyMessage(result.responseText, result.NotifyColor);
                            mainController.RefreshDettaglioCarrello();
                            waitingBS.Hide();
                            return true;
                        }
                        else {
                            mainController.NotifyMessage(result.responseText, result.NotifyColor);
                            waitingBS.Hide();
                            return false;
                        }
                    }
                    catch (err) {
                        console.log(err);
                        mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), 'error');
                        waitingBS.Hide();
                        return false;
                    }
                },
                error: function (xhr, status, error) {
                    mainController.NotifyMessage(mainController.GetLabel('lWishlistKoRinomina'), 'error');
                    waitingBS.Hide();
                    return false;
                }
            });
        }
        catch (error) {
            waitingBS.Hide();
        }
    }

    return {
        "AddCart": AddCart,
        "AccountAddCart": AccountAddCart,
        "UpdateCart": UpdateCart,
        "AccountUpdateCart": AccountUpdateCart,
        "EmptyCart": EmptyCart,
        "AccountEmptyCart": AccountEmptyCart,
        "RegisterOrder": RegisterOrder,
        "GetShippingCost": GetShippingCost,
        "AccountDeleteOrderRow": AccountDeleteOrderRow,
        "FinalOrderCheck": CheckFinaleOrdine,
        "UsaCodiceSconto": UsaCodiceSconto,
        "ConcludiOrdineCarrello": ConcludiOrdineCarrello,
        "AnnullaPrenotazioneGiftCard": AnnullaPrenotazioneGiftCard,
        "AddCartBulk": AddCartBulk

    }
})();

/**
 * ACCOUNT
 * */
var accountController = (function () {

    function PlaceholderProvince(lcid) {
        if (lcid == 1034) {
            return mainController.GetLabel('lCittaFatturazione');
        }
        else {
            return mainController.GetLabel('lProvinciaFatturazione');
        }
    }

    /**
     * Imposta un indirizzo di spedizione come predefinito.
     * @param {int} i - id univoco dell'indirizzo di spedizione
     * */
    function SetDefaultAddress(i) {
        waitingBS.Show();
        try {
            var r = mainController.CallService('/Account/SetIndirizzoDefault', i);
            if (r.esito == Costanti.ESITO_OK) {
                window.location.reload();
            }
            else {
                waitingBS.Hide();
                mainController.NotifyMessage(r.responseText, r.NotifyColor);
            }
        }
        catch (error) {
            console.log(error);
            waitingBS.Hide();
        }
    }

    /**
     * Elimina un indirizzo di spedizione.
     * @param {number} i l'id dell'indirizzo da eliminare
     */
    function DeleteAddress(i) {
        var r = mainController.CallService('/Account/EliminaIndirizzo', i);
        if (r.esito == Costanti.ESITO_OK) {
            window.location.reload();
        }
        else {
            mainController.NotifyMessage(r.responseText, r.NotifyColor);
        }
    }


    /**
    * Aggiorna i campi del form di registrazione in base alla combinazione dell'lcid del sito e del tipo utente selezionato.
    * @param {number} id
    */
    function UpdateForm(id) {
        try {

            waiting.Show();

            params = {
                Id: id
            };

            if (parseInt(id) > 0) {
                mainController.CallServiceHtmlAsync('/Account/RefreshFormRegistrazione', params)
                    .then(function (result) {
                        try {
                            $('#form-content').removeClass('disabledfn');
                            $('#form-content').html(result);

                            if (id == '3') {
                                $('#reg-cf').attr('maxlength', '11');

                                $('#reg-cf').inputFilter(function (value) {
                                    return /^-?\d*$/.test(value);
                                }, 'Must be an integer');
                            }
                            if (id == '2') {
                                $('#lb-cf').addClass('hidden');
                                $('#lb-cf').css('display', 'none');
                                $('#reg-cf').addClass('hidden');
                            }
                            else {
                                $('#reg-cf').attr('maxlength', '16');
                            }

                            waiting.Hide();
                            initAutocomplete();
                        }
                        catch (error) {
                            console.log(error);
                            waiting.Hide();
                        }
                    })
                    .catch(function (xhr, status, error) {
                        console.log(error);
                        console.log(status);
                        console.log(xhr);
                        waiting.Hide();
                    });
            }
            else {
                $("#form-content").addClass("disabledfn");
                waiting.Hide();
            }

        }
        catch (error) {
            console.log(error);
            waiting.Hide();
        }
    }

    /**
     * Iscrive un utente al programma plus
     * @param {any} iduser
     */
    function IscriviPlus(iduser) {
        try {
            if (iduser && iduser > 0) {
                waitingBS.Show();
                var param = {
                    idUser: iduser
                }
                mainController.CallServiceAsync('/Account/IscriviUtentePlus', param)
                    .then(risp => {
                        if (risp && risp.esito) {
                            mainController.NotifyMessage(risp.responseText, risp.NotifyColor);
                            if (risp.esito == Costanti.ESITO_OK) {
                                setTimeout(function () {
                                    window.location.reload();
                                }, 2000);
                            }
                            else {
                                waitingBS.Hide();
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        waitingBS.Hide();
                    })
            }
            else {
                $('#popuplogin').dxPopup('show');
            }
        }
        catch (error) {
            console.log(error)
            waitingBS.Hide();
        }
    }

    return {
        "SetDefaultAddress": SetDefaultAddress,
        "DeleteAddress": DeleteAddress,
        "PlaceholderProvince": PlaceholderProvince,
        "UpdateFormRegistrazione": UpdateForm,
        "IscriviPlus": IscriviPlus
    }
})();

var waiting = (function () {
    /**
     * Visualizza un layer con uno spinner di attesa.
     * */
    function Show(msg) {

        var loadPanel = $("#loadPanel").dxLoadPanel("instance");
        message = mainController.GetLabel('lMessaggioCaricamento');

        if (msg && msg.length > 0) {
            message = msg;
        }
        loadPanel.option(message);

        return loadPanel.show();
    }

    /**
     * Nascondo il layer di attesa.
     * */
    function Hide() {
        setTimeout(() => {
            return $("#loadPanel").dxLoadPanel("instance").hide();
        }, 100);
    }
    return {
        "Show": Show,
        "Hide": Hide
    }
})();

var showing;
var waitingBS = (function () {
    /**
     * Visualizza un layer con uno spinner di attesa.
     * @param msg messaggio personalizzato da visualizzare all'interno della finestra modal
     * @param size dimensioni della finestra modal (sm, lg, xl)
     * */
    function Show(msg, size) {

        var dialog = $('#bootstrapWaitingforModal');

        if (dialog && (showing == false || !showing)) {
            showing = true;
            var opt = {};
            if (size != '') {
                opt.dialogSize = size;
            }

            opt.headerSize = 4;
            opt.headerText = false;
            if (msg) {
                waitingDialog.show(msg, opt);
            }
            else {
                waitingDialog.show(mainController.GetLabel('lMessaggioCaricamento'), opt);
            }
        }
    }

    /**
     * Nascondo il layer di attesa.
     * */
    function Hide() {
        showing = false;
        waitingDialog.hide();
    }
    return {
        "Show": Show,
        "Hide": Hide
    }
})();


$(document).ready(function () {
    $("form#fregistrazione :input").focusout(function () {
        if ($(this).val())
            $(this).removeClass('is-invalid');
    })
    //controllo esistenza profilo con stessa email
    var tipoUtente = $('#reg-tipologiacliente');

    if (tipoUtente.length > 0 && tipoUtente.val() != '0') {
        $("#reg-email").focusout(function () {
            var email = $("#reg-email").val();
            if (email != null && email != undefined && email != '') {
                waitingBS.Show('Controllo esistenza account', 'lg', 'info');

                $("#reg-email").removeClass('is-valid');
                $("#reg-email").removeClass('is-invalid');
                if (mainController.CheckEmail(email)) {
                    var c = {};
                    c.email = email;

                    mainController.CallServiceAsync("/Home/CheckUserNotExists", c, true)
                        .then(function (result) {
                            if (result === true)
                                $("#reg-email").addClass('is-valid');
                            else {
                                $("#reg-email").addClass('is-invalid');
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
                else {
                    $("#reg-email").addClass('is-invalid');
                }

                waitingBS.Hide();
            }
            else {
                $("#reg-email").removeClass('is-valid');
                $("#reg-email").removeClass('is-invalid');
            }

        });
    }
});

function ClearClass(element, classname) {
    if (element.classList.contains(classname)) {
        element.classList.remove(classname)
    }
}

/**
 * Permette il filtraggio o la mostra di più prodotti nel catalogo
 * @param {object} data Dati passati dal controllo di devexpress (non usati)
 * @param {int} pag Paginazione usata per mostrare più prodotti dopo un filtraggio
 * @param {string} idcat Id della categoria di cui vogliamo i prodotti 
 * @param {string} direction  Direzione della posizione dei filtri h = orizzontale altrimenti verticale
 */
function SortGridProdottiInner(data, pag, idcat, direction, ismaster, sorting) {
    if (filtra) {
        var panel = $('#LoadPanelCatalogo');
        if (panel.length > 0) {
            panel.dxLoadPanel('instance').option('visible', true);
        }
        else {
            waitingBS.Show();
        }

        try {
            var marcheitems = "";
            var promoitem = false;
            var dispitem = false;
            var dispitemGiorni = false;
            var listinoitem = false;
            var variantiitems = [];
            master = "true";

            switch (direction) {
                case 'h':
                    if ($("#filtromarcah").length > 0) {
                        if ($("#filtromarcah").dxList('instance').option("selectedItems") !== undefined || $("#filtromarcah").dxList('instance').option("selectedItems") !== null) {
                            marcheitems = $("#filtromarcah").dxList('instance').option("selectedItems");
                        }
                    }
                    break;
                default:
                    if ($("#filtromarca").length > 0) {
                        if ($("#filtromarca").dxList('instance').option("selectedItems") !== undefined || $("#filtromarca").dxList('instance').option("selectedItems") !== null) {
                            marcheitems = $("#filtromarca").dxList('instance').option("selectedItems");
                        }
                    }
                    break;
            }
            if ($("#filtropromozionih").length > 0) {
                promoitem = $("#filtropromozionih").dxCheckBox('instance').option('value');
            }
            if ($("#filtrodisponibileingiornih").length > 0) {
                dispitemGiorni = $("#filtrodisponibileingiornih").dxCheckBox('instance').option('value');
            }
            if ($("#filtrodisponibilih").length > 0) {
                dispitem = $("#filtrodisponibilih").dxCheckBox('instance').option('value');
            }
            if ($("#filtroprodslistinoh").length > 0) {
                var filtrolistino = $("#filtroprodslistinoh").dxCheckBox('instance');
            }

            if (filtrolistino != null && filtrolistino != undefined) {
                listinoitem = filtrolistino.option('value');
            }


            var listdivvarianti = $('[id^="filtrovariante_"]');
            $.each(listdivvarianti, function (key, value) {
                var idfiltro = '#' + value.id;

                if ($(idfiltro).dxList('instance').option("selectedItems") !== undefined || $(idfiltro).dxList('instance').option("selectedItems") !== null) {
                    $.merge(variantiitems, $(idfiltro).dxList('instance').option("selectedItems"));
                    master = ismaster;
                }
            });

            var variantilist = "";
            $.each(variantiitems, function (key, value) {
                variantilist += "|" + value.Key;
            });

            var marchelist = "";
            $.each(marcheitems, function (key, value) {
                if (value && value.Key) {
                    marchelist += "|" + value.Key;
                }
            });

            if (pag === null || pag === undefined || pag < 0) {
                pag = 0;
            }

            if (variantiitems.length == 0) {
                master = true;
            }

            if (promoitem == true || dispitem == true || dispitemGiorni == true) {
                master = false;
            }

            if (!sorting) {
                sorting = 'SPECIAL|Descending';
            }

            var params = {
                idc: idcat,
                page: pag,
                ismaster: master,
                sort: sorting, //asc o desc
                marche: marchelist,
                promo: promoitem,
                varianti: variantilist,
                aggprodotti: showmoreproducts,
                solodisp: dispitem,
                solodispgiorni: dispitemGiorni,
                sololistino: listinoitem
            };

            $.ajax({
                url: '/GetGridProdotti',
                type: 'POST',
                data: params,
                success: function (result) {
                    try {
                        if (showmoreproducts == false) {
                            $("#ProductsCard").html(result);
                            pagina = 0;
                        }
                        else {
                            $("#GrigliaProdotti").append(result);
                        }
                        var tot = $("#totalresults" + pag).val();
                        var ps = $("#pagesize").val();
                        var totcards = $("#totalcards" + pag).val();
                        if (!tot) {
                            tot = '0';
                        }
                        $("#numerotot").html(tot)
                        showmoreproducts = false;
                        showing = false;
                        if (parseInt(totcards) >= parseInt(ps)) {
                            if (((parseInt(tot) / parseInt(ps)) - 1) > pag) {
                                $("#btnshowmore").removeClass("hidden");
                            }
                            else {
                                $("#btnshowmore").addClass("hidden");
                            }
                        }
                        else {
                            $("#btnshowmore").addClass("hidden");
                        }
                        if (marchelist.length > 0 || variantilist.length > 0 || promoitem == true) {
                            $("#clearfilters").removeClass("hidden");
                        }
                        if (variantiitems.length == 0 && marchelist.length == 0 && variantiitems.length == 0) {
                            $("#clearfilters").addClass("hidden");
                        }
                        var urlString = window.location.href;
                        var url = new URL(urlString);
                        //Controllo la query string per promo
                        var promo = url.searchParams.get("promo");

                        if (promo == 'true' && promoitem == false) {
                            window.location.href = window.location.href.replace('Promozioni', 'Catalogo').replace('?promo=true', '');
                        }
                        if ($("#filtromarcah").length > 0) {
                            var val = $("#filtromarcah").dxList('instance').option('dataSource').store._array[0].Value.replaceAll(' ', '').replaceAll('.', '');
                            //console.log("num-filter-" + val);
                            if (val) {
                                var element = $("#num-filter-" + val)[0];
                                if (element) {
                                    if (marcheitems.length > 0) {
                                        element.innerHTML = marcheitems.length;
                                        element.classList.remove('hidden');
                                    }
                                    else if (marcheitems.length == 0) {
                                        element.classList.add('hidden');
                                    }
                                }
                            }
                        }

                        $.each(listdivvarianti, function (key, value) {
                            var idfiltro = '#' + value.id;
                            var option = $(idfiltro).dxList('instance').option("selectedItems");
                            if (option !== undefined || option !== null) {
                                var idVar = value.id.split('_')[1];
                                var element = $("#num-filter-" + idVar)[0];
                                if (element) {
                                    if (option.length > 0) {
                                        element.innerHTML = option.length;
                                        element.classList.remove('hidden');
                                    }
                                    else if (option.length == 0) {
                                        element.classList.add('hidden');
                                    }
                                }
                            }
                        });

                        //if (document.readyState === 'ready' || document.readyState === 'complete') {

                        var panel = $('#LoadPanelCatalogo');
                        if (panel.length > 0) {
                            panel.dxLoadPanel('instance').option('visible', false);
                        }
                        else {
                            waitingBS.Hide();
                        }
                        //}
                    }
                    catch (error) {
                        console.log(error);
                        var panel = $('#LoadPanelCatalogo');
                        if (panel.length > 0) {
                            panel.dxLoadPanel('instance').option('visible', false);
                        }
                        else {
                            waitingBS.Hide();
                        }
                    }
                },
                error: function (xhr, status, error) {
                    console.log(error);
                    console.log(xhr);
                    var panel = $('#LoadPanelCatalogo');
                    if (panel.length > 0) {
                        panel.dxLoadPanel('instance').option('visible', false);
                    }
                    else {
                        waitingBS.Hide();
                    }
                }
            });
        }
        catch (error) {
            console.log(error);
            var panel = $('#LoadPanelCatalogo');
            if (panel.length > 0) {
                panel.dxLoadPanel('instance').option('visible', false);
            }
            else {
                waitingBS.Hide();
            }
        }
    }
}


/**
 * Permette la pulizia dei filtri della griglia del catalogo,
 * la variabile 'filtra' permette di non inviare tante richieste quanti sono i controlli puliti
 */
var filtra = true;
function ClearFilters(idcat) {
    try {
        filtra = false;

        var listdivvarianti = $('[id^="filtro"]');
        $.each(listdivvarianti, function (key, value) {
            if (value.id.toLowerCase() != 'filtropromozionih'
                && value.id.toLowerCase() != 'filtrodisponibilih'
                && value.id.toLowerCase() != 'filtrodisponibileingiornih'
                && value.id.toLowerCase() != 'filtroprodslistinoh') {
                var idfiltro = '#' + value.id;
                $(idfiltro).dxList('instance').option("selectedItemKeys", new Array);
            }
        });


        if ($("#filtropromozionih").length > 0) {
            $("#filtropromozionih").dxCheckBox('instance').option('value', false)
        }
        if ($("#filtrodisponibilih").length > 0) {
            $("#filtrodisponibilih").dxCheckBox('instance').option('value', false)
        }
        if ($("#filtrodisponibileingiornih").length > 0) {
            $("#filtrodisponibileingiornih").dxCheckBox('instance').option('value', false);
        }

        var master = true;

        filtra = true;
        SortGridProdottiInner(null, 0, idcat, 'h', master);
        $("#clearfilters").addClass("hidden");
    }
    catch (error) {
        console.log(error);
    }
}



function UpdateDDLProvincia(idInd) {

    var fnazione = $('#reg-fnazione' + (idInd ? idInd : ''));
    var snazione = $('#reg-snazione' + (idInd ? idInd : ''));
    var nazione = $('#Nazione' + (idInd ? idInd : ''));

    if (fnazione && fnazione.length > 0) {
        var fcountry = fnazione.val();

        var idProvF = "reg-fprovincia";
        idProvF = idInd ? (idProvF + idInd) : idProvF;
        var ddlProvincef = $('#' + idProvF).dxSelectBox('instance');

        ControllaNazione(fcountry, ddlProvincef);
    }
    if (snazione && snazione.length > 0) {
        var scountry = snazione.val();

        var idProvS = "reg-sprovincia";
        idProvS = idInd ? (idProvS + idInd) : idProvS;
        var ddlProvinces = $('#' + idProvS).dxSelectBox('instance');

        ControllaNazione(scountry, ddlProvinces);
    }

    if (nazione && nazione.length > 0) {
        var country = nazione.val();
        var ddlProvince;

        var idProvS = "reg-sprovincia";
        idProvS = idInd ? (idProvS + idInd) : idProvS;

        var idProvF = "reg-fprovincia";
        idProvF = idInd ? (idProvF + idInd) : idProvF;

        if ($('#' + idProvS).data()) {
            ddlProvince = $('#' + idProvS).dxSelectBox('instance');
            ControllaNazione(country, ddlProvince);
        }
        else if ($('#' + idProvF).data()) {
            ddlProvince = $('#' + idProvF).dxSelectBox('instance');
            ControllaNazione(country, ddlProvince);
        }
    }
}

function ControllaNazione(nazione, ddlProvince) {
    switch (nazione) {
        case "LI":
        case "SM":
            ddlProvince.option('disabled', true);
            ddlProvince.option('value', null);
            ddlProvince.option('isValid', true);
            $('#h' + ddlProvince._$element[0].id).val('San Marino');
            break;
        case "CH":
        case "IT":
        default:
            ddlProvince.option('disabled', false);
            break;
    }
}


function CheckNuovoIndirizzo(lcid, idInd) {
    var formstate = true;

    $('form#finsertorupdateindirizzospedizione' + (idInd > 0 ? idInd : 0) + ' :input').each(function (index, value) {
        var localId = value.id;
        if (idInd && !value.id.includes(idInd)) {
            localId += idInd;
        }
        $('#' + localId).removeClass('is-invalid');
        if ($('#' + localId).attr('required') && ($('#' + localId)[0].disabled == false || !$('#' + localId).attr('disabled'))) {
            var localVal = $('#' + localId).val();
            if (!localVal?.trim()) {
                $('#' + localId).addClass('is-invalid');
                formstate = false;
            }
        }
    });

    // Controllo del CAP
    if (CheckCapReg($('#CAP' + idInd), lcid, $('#errorecap' + idInd)) == false) {
        formstate = false;
    }

    if (CheckCittaEProvincia(lcid, idInd) == false) {
        formstate = false;
    }

    var telefono = $('#Telefono' + idInd);
    var cellulare = $('#Cellulare' + idInd);
    var errore = $('#erroreTelefono' + idInd);
    if (!telefono.val() && !cellulare.val()) {
        formstate = false;
        errore.removeClass('hidden');
        telefono.addClass('is-invalid');
        cellulare.addClass('is-invalid');
    }
    else {
        errore.addClass('hidden');
        telefono.removeClass('is-invalid');
        cellulare.removeClass('is-invalid');


        if (telefono.val().length > 0) {
            var risPref = CheckPrefisso('select_prefisso_tel_sped_' + idInd);
            if (risPref != true) {
                formstate = false;
            }
        }
        else {
            var risPref = CheckPrefisso('select_prefisso_cell_sped_' + idInd);
            if (risPref != true) {
                formstate = false;
            }
        }
    }

    return formstate;
}

/**
 * Controlla un cap assicurandosi che sia numerico e di una lunghezza stabilita
 * @param {any} cap
 * @param {any} lunghezza
 * @param {any} controllo elemento di controllo che fa visualizzare un messaggio di errore
 * @returns
 */
function CheckCapNumericoReg(cap, lunghezza, controllo) {
    try {
        var isnumCap = /^\d+$/.test(cap.val());

        if (isnumCap == false) {
            cap.addClass('is-invalid');
            return false;
        }
        else {
            if (cap.val().length != lunghezza) {
                cap.addClass('is-invalid');
                if (controllo != undefined) {
                    controllo.html(mainController.GetLabel('lErroreLunghezzaCAP'));
                    controllo.removeClass('hidden');
                }
                return false;
            }
            else {
                cap.removeClass('is-invalid');
                if (controllo != undefined) {
                    controllo.html('');
                    controllo.addClass('hidden');
                }
            }
        }
        return true;
    }
    catch (error) {
        console.log(error);
        return false;
    }
}

function CheckCittaEProvincia(lcid, idInd) {

    var risp = true;

    if (lcid && lcid > 0) {
        switch (lcid) {
            case 1034:
            case 1040:

                var idFCitta = 'reg-fcitta';
                var idSCitta = 'reg-scitta';
                var idFProvincia = 'reg-fprovincia';
                var idSProvincia = 'reg-sprovincia';

                if (idInd) {
                    idFCitta += idInd;
                    idSCitta += idInd;
                    idFProvincia += idInd;
                    idSProvincia += idInd;
                }

                if (lcid == 1034) {
                    if ($('#' + idFCitta).length > 0) {
                        var fSelectBox = $('#' + idFCitta).dxSelectBox('instance');
                        var fcitta = fSelectBox.option('value')

                        if (!fcitta) {
                            fSelectBox.option('isValid', false);
                            risp = false;
                        }
                        else {
                            fSelectBox.option('isValid', true);
                        }
                    }
                    if ($("#cbshippingsameaddress").length == 0 || ($("#cbshippingsameaddress").length > 0 && $("#cbshippingsameaddress")[0].checked)) {
                        if ($('#' + idSCitta).length > 0) {
                            var sSelectBox = $('#' + idSCitta).dxSelectBox('instance');
                            var scitta = sSelectBox.option('value')

                            if (!scitta) {
                                sSelectBox.option('isValid', false);
                                risp = false;
                            }
                            else {
                                sSelectBox.option('isValid', true);
                            }
                        }
                    }
                }

                if ($('#' + idFProvincia).length > 0) {
                    var fSelectBox = $('#' + idFProvincia).dxSelectBox('instance');
                    var fprovincia = fSelectBox.option('value')

                    if (!fprovincia && fSelectBox.option('disabled') == false) {
                        fSelectBox.option('isValid', false);
                        risp = false;
                    }
                    else {
                        fSelectBox.option('isValid', true);
                    }
                }

                if ($('#' + idSProvincia).length > 0) {
                    var sSelectBox = $('#' + idSProvincia).dxSelectBox('instance');
                    var sprovincia = sSelectBox.option('value')

                    if ($("#cbshippingsameaddress").length == 0 || ($("#cbshippingsameaddress").length > 0 && $("#cbshippingsameaddress")[0].checked)) {
                        if (!sprovincia && sSelectBox.option('disabled') == false) {
                            sSelectBox.option('isValid', false);
                            risp = false;
                        }
                        else {
                            sSelectBox.option('isValid', true);
                        }
                    }
                }
                break;
            default:

                var elemFProv = $('#' + idFProvincia);
                if (elemFProv.length > 0) {
                    var fprovincia = elemFProv.val();
                    if (!fprovincia) {
                        risp = false;
                        elemFProv.addClass('is-invalid');
                    }
                    else {
                        elemFProv.removeClass('is-invalid');
                    }
                }

                var elemSProv = $('#' + idSProvincia);
                if (elemSProv.length > 0) {
                    var sprovincia = elemSProv.val();
                    if (!sprovincia) {
                        risp = false;
                        elemSProv.addClass('is-invalid');
                    }
                    else {
                        elemSProv.removeClass('is-invalid');
                    }
                }
                break;
        }
    }
    else {
        risp = false;
    }
    return risp;
}

var emailNonEsistente = false;

/**
 * Controlla se un utente è già registrato
 * @param {string} email L'email
 */
function CheckEmailReg(email, s) {

    var divReset = $('#divResetPwd');
    var regEmail = $('#reg-email');
    regEmail.removeClass('is-invalid');

    divReset.html('');

    if (mainController.CheckEmail(email)) {

        var param = {
            email: email
        }

        mainController.CallServiceAsync('/checkUserNotExists', param)
            .then((risp) => {
                if (risp == true) {
                    if (s != "undefined") {
                        $("#accountexist").show("slow");
                        $("#fevento").hide("slow");
                        $("#pagecontent").hide("slow");
                    }
                }
                else {
                    regEmail.addClass('is-invalid');

                    divReset.html(mainController.GetLabel('RegEmailGiaRegistrataReset'));
                }
                emailNonEsistente = risp;
            })
            .catch(function (error) {
                console.log(error);
                emailNonEsistente = false;
            });
    }
    else {
        regEmail.addClass('is-invalid');
    }

}

function CheckLoginNameExists(loginName) {
    var param = {
        LoginName: loginName
    }
    mainController.CallServiceAsync('/checkLoginNameNotExists', param)
        .then(function (risp) {
            if (risp == false) {
                $('#checkLoginName').html(mainController.GetLabel('LoginNameGiaPresente'));
                $('#checkLoginName').removeClass('hidden');
                $('#reg-loginName').addClass('is-invalid');
            }
            else {
                $('#checkLoginName').addClass('hidden');
                $('#reg-loginName').removeClass('is-invalid');

            }
        })
        .catch(function (error) {
            console.log(error);
        });
}

/**
 * Controlla il CAP della registrazione in base all'LCID
 * @param {string} cap Il CAP
 * @param {number} lcid L'LCID
 * @param {any} controllo elemento di controllo che fa visualizzare un messaggio di errore
 * @returns {boolean}
 */
function CheckCapReg(cap, lcid, controllo) {
    try {
        if (!cap.val() || cap.val() == '') {
            cap.addClass('is-invalid');
            if (controllo != undefined) {
                controllo.html(mainController.GetLabel('lErroreLunghezzaCAP'));
                controllo.removeClass('hidden');
            }
            return false;
        }
        else {
            cap.removeClass('is-invalid');
            switch (lcid) {
                case 1040: //italiano
                case 1034: //spagnolo
                case 1036: //francese
                case 1027: //spagnolo catalano
                    return CheckCapNumericoReg(cap, 5, controllo);
                case 2055: //svizzera tedesca
                case 2064: //svizzera italiana
                case 4108: //svizzera francese
                case 3079: //austria
                    return CheckCapNumericoReg(cap, 4, controllo);
                case 2070: //portogallo
                    var capPT = /^\d{4}-\d{3}$/.test(cap.val());
                    if (capPT == false) {
                        cap.addClass('is-invalid');
                        if (controllo != undefined) {
                            controllo.html(mainController.GetLabel('lErroreLunghezzaCAP'));
                            controllo.removeClass('hidden');
                        }
                        return false;
                    }
                    else {
                        cap.removeClass('is-invalid');
                        if (controllo != undefined) {
                            controllo.html('');
                            controllo.addClass('hidden');
                        }
                        return true;
                    }
                default:
                    if (controllo != undefined) {
                        controllo.html('');
                        controllo.addClass('hidden');
                    }
                    return true;
            }
        }
    }
    catch (error) {
        console.log(error);
        return false;
    }
}

/**
 * Verifica la corretta compilazione dei campi password e le policy di sicurezza sulla stringa digitata.
 * @param {Element} password il campo password passato con JQuery.
 * @param {Element} cpassword il campo di conferma della password passato con JQuery.
 * @param {Element} controllo il campo del messaggio di errore della password passato con JQuery.
 * @param {number} idsito il campo del messaggio di errore della password passato con JQuery.
 * @param {boolean} controlloAccount un parametro che specifica esplicitamente di utilizzare la regex di controllo della password degli account.
 * @returns {boolean} true se la password è corretta, altrimenti false.
 */
function CheckPassword(password, cpassword, controllo, idsito, controlloAccount) {
    var esito = true;

    try {
        cpassword.removeClass('is-invalid');
        password.removeClass('is-invalid');
        controllo.removeClass('d-block');

        controllo.html('');
        var pass1 = password.val();
        var pass2 = cpassword.val();

        if (pass1 == null || pass1 == undefined || pass1.length == 0) {
            password.addClass('is-invalid');
            esito = false;
        }

        if (pass2 == null || pass2 == undefined || pass2.length == 0) {
            cpassword.addClass('is-invalid');
            esito = false;
        }

        if ((idsito > 0 && idsito != 46 && !strongPassword.test(pass1))
            || (idsito > 0 && idsito == 46 && !strongPasswordAccount.test(pass1))) {
            esito = false;
            password.addClass('is-invalid');
            controllo.html(mainController.GetLabel('lerrorepasswordnonsicura'));
            controllo.addClass('d-block');
        }
        else if (!pass1 || !pass2) {
            esito = false;
            cpassword.addClass('is-invalid');
            controllo.html(mainController.GetLabel('lerrorepasswordvuota'));
            controllo.addClass('d-block');
        }
        else if (pass1 != pass2) {
            esito = false;
            cpassword.addClass('is-invalid');
            controllo.html(mainController.GetLabel('cvpassword'));
            controllo.addClass('d-block');
        }
    }
    catch (error) {
        console.log(error);
        return false;
    }
    return esito;
}

/**
 * Controlla se un account esiste o no
 * @param {string} Username
 * @param {string} Email
 */
function CheckAccountExists(Username, Email) {

    var params = {
        username: Username,
        email: Email
    };
    var risp = false;

    $.ajax({
        url: '/CheckAccountExists',
        type: 'POST',
        data: params,
        async: false,
        headers: {
            "Authorization": "Basic " + btoa("Chi Sara:Non la so")
        },
        success: function (result) {
            try {
                if (!result) {
                    //mainController.GetLabel('lAccountInesistente')
                    mainController.NotifyMessage('account inesistente', 'error');
                    risp = false;
                }
                else {
                    risp = true;
                }
            }
            catch (error) {
                console.log(error);
                risp = false;
            }
        },
        error: function (xhr, status, error) {
            console.log(error);
            console.log(xhr);
            mainController.NotifyMessage('ERROR!', 'error')
            risp = false;
        }
    });
    return risp;
}


function CheckFormModificaAccount(idsito) {
    try {
        var inputemail = $('#newemail');
        var inputoldemail = $('#oldemail');
        var inputoldpassword = $('#oldpassword');
        var inputpassword = $('#newpassword');
        var inputconfermapassword = $('#confermanewpassword');
        var chkpassword = $('#chkpassword');

        var campiPassword = [inputoldpassword, inputpassword, inputconfermapassword];

        var newemailvalue = inputemail.val()?.trim();
        var oldpasswordvalue = inputoldpassword.val()?.trim();
        var newpasswordvalue = inputpassword.val()?.trim();
        var confermapasswordvalue = inputconfermapassword.val()?.trim();

        var formstate = true;

        if (!newemailvalue && !oldpasswordvalue && !newpasswordvalue && !confermapasswordvalue) { // Tutti i campi vuoti
            inputemail.addClass('is-invalid');
            inputoldpassword.addClass('is-invalid');
            inputpassword.addClass('is-invalid');
            inputconfermapassword.addClass('is-invalid');
            formstate = false;
        }

        //if (newemailvalue != '' && mainController.CheckEmail(newemailvalue) == false) { // Email inserita ma non è una mail
        //    inputemail.addClass('is-invalid');
        //    mainController.NotifyMessage(mainController.GetLabel('lemailnonvalida'), Costanti.NOTIFY_COLOR_ERROR);
        //    formstate = false;
        //}

        var pwconvalore = campiPassword.filter(function (element, index) { // Controllo se c'è uno dei campi password con valore
            return element.val()?.trim() != '';
        });

        if (pwconvalore.length > 0) {
            var pwsenzavalore = campiPassword.filter(function (element, index) { // Controllo se c'è uno dei campi password senza valore
                return element.val()?.trim() == '';
            });

            if (pwsenzavalore.length > 0) {
                campiPassword.forEach(function (element, index) {
                    element.removeClass('is-invalid');
                    pwsenzavalore.forEach(function (element2, index2) {
                        if (element2.attr('id') == element.attr('id')) { // Se un elemento è senza valore gli metto che non è valido
                            element.addClass('is-invalid');
                            formstate = false;
                        }
                    });
                });
            }

            if (CheckPassword(inputpassword, inputconfermapassword, chkpassword, idsito) == false) {
                formstate = false;
            }
        }

        if (formstate == true) {

            waitingBS.Show();
            var params = {
                email: newemailvalue,
                vecchiapassword: oldpasswordvalue,
                password: newpasswordvalue,
                confermapassword: confermapasswordvalue
            };

            mainController.CallServiceAsync('/Account/ModificaEmailOPassword', params)
                .then(result => {
                    try {
                        if (result) {
                            if (result.esito == Costanti.ESITO_OK) {
                                setTimeout(function () {
                                    location.href = '/Account/Home';
                                }, 1500);
                            }
                            else {
                                waitingBS.Hide();
                            }
                            mainController.NotifyMessage(result.responseText, result.NotifyColor);
                            return false;
                        }
                        else {
                            mainController.NotifyMessage(mainController.GetLabel('lErroreGenericoSalvataggio'), Costanti.NOTIFY_COLOR_ERROR);
                            waitingBS.Hide();
                            return false;
                        }
                    }
                    catch (error) {
                        console.log(error);
                        mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), Costanti.NOTIFY_COLOR_ERROR);
                        waitingBS.Hide();
                        return false;
                    }
                })
                .catch(error => {
                    console.log(error);
                    mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), Costanti.NOTIFY_COLOR_ERROR);
                    waitingBS.Hide();
                    return false;
                });

        }
    }
    catch (error) {
        console.log(error);
        return false;
    }
    return false;
}

function ESDoc(value) {
    var results = ValidateSpanishID.spainIdType(value);

    if (!results) {
        return false;
    }
    else {
        switch (results) {
            case 'dni':
                if (ValidateSpanishID.validDNI(value) == false) {
                    return false;
                }
                break;
            case 'cif':
                if (ValidateSpanishID.validCIF(value) == false) {
                    return false;
                }
                break;
            case 'nie':
                if (ValidateSpanishID.validNIE(value) == false) {
                    return false;
                }
                break;
            case undefined:
                return false;
                break;
            default:
                return true;
        }
    }
}

ValidateSpanishID = (function () {
    'use strict';

    var DNI_REGEX = /^(\d{8})([A-Z])$/;
    var CIF_REGEX = /^([ABCDEFGHJKMNPQRSUVW])(\d{7})([0-9A-J])$/;
    var NIE_REGEX = /^[LXYZ]\d{7,8}[A-Z]$/;

    var ValidateSpanishID = {};

    ValidateSpanishID.spainIdType = function (str) {
        if (str.match(DNI_REGEX)) {
            return 'dni';
        }
        if (str.match(CIF_REGEX)) {
            return 'cif';
        }
        if (str.match(NIE_REGEX)) {
            return 'nie';
        }
        return undefined;
    };

    ValidateSpanishID.validDNI = function (dni) {

        if (!dni.match(DNI_REGEX)) {
            return false;
        }

        var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
        var letter = dni_letters.charAt(parseInt(dni, 10) % 23);

        return letter == dni.charAt(8);
    };

    ValidateSpanishID.validNIE = function (nie) {

        if (!nie.match(NIE_REGEX)) {
            return false;
        }

        // Change the initial letter for the corresponding number and validate as DNI
        var nie_prefix = nie.charAt(0);

        switch (nie_prefix) {
            case 'X':
            case 'L':
                nie_prefix = 0; break;
            case 'Y': nie_prefix = 1; break;
            case 'Z': nie_prefix = 2; break;
        }

        return ValidateSpanishID.validDNI(nie_prefix + nie.substr(1));

    };

    ValidateSpanishID.validCIF = function (cif) {

        var match = cif.match(CIF_REGEX);
        if (match == null) return false;
        var letter = match[1],
            number = match[2],
            control = match[3];

        var even_sum = 0;
        var odd_sum = 0;
        var n;

        for (var i = 0; i < number.length; i++) {
            n = parseInt(number[i], 10);

            // Odd positions (Even index equals to odd position. i=0 equals first position)
            if (i % 2 === 0) {
                // Odd positions are multiplied first.
                n *= 2;

                // If the multiplication is bigger than 10 we need to adjust
                odd_sum += n < 10 ? n : n - 9;

                // Even positions
                // Just sum them
            } else {
                even_sum += n;
            }

        }

        var control_digit = (10 - (even_sum + odd_sum).toString().substr(-1));

        if (control_digit == 10) { control_digit = 0; }

        var control_letter = 'JABCDEFGHI'.substr(control_digit, 1);

        // Control must be a digit
        if (letter.match(/[H]/)) {
            return control == control_digit;

            // Control must be a letter
        } else if (letter.match(/[KPQS]/)) {
            return control == control_letter;

            // Can be either
        } else {
            return control == control_digit || control == control_letter;
        }

    };

    return ValidateSpanishID;
})();

function ShowPopUp() {
    $("#cookie-popup").dxPopup("show");
}

/**
 * Crea una nuova wishlist.
 */
function CreateWishlist(nome, url, showWaiter) {
    try {
        if (showWaiter != false) {
            waitingBS.Show();
        }

        var params = {
            nome: nome
        };

        $.ajax({
            url: '/Account/NuovaWishlist',
            type: 'POST',
            data: params,
            success: function (result) {
                try {
                    if (result.esito == Costanti.ESITO_OK) {
                        const popup = $('#Wishlist_Popup').dxPopup('instance');
                        if (!url) {
                            popup.hide();
                            if (showWaiter != false) {
                                waitingBS.Show();
                            }
                            mainController.NotifyMessage(result.responseText.split('|')[0], result.NotifyColor);
                            setTimeout(function () {
                                location.reload();
                            }, 500);
                        }
                        else {
                            if (url.includes('/Prodotti/')) {
                                popup.option({
                                    contentTemplate: $('#AddProductToWishlist')
                                });
                                setTimeout(function () {
                                    $('#ListaDiWishlist').dxList('instance').option('selectedItemKeys', '' + result.responseText.split('|')[1]);
                                    //setTimeout(function () {
                                    //    $('#btnAddToWishlist').click();
                                    //}, 50);
                                }, 75);
                            }
                        }
                    }
                    else {
                        mainController.NotifyMessage(result.responseText.split('|')[0], result.NotifyColor);
                    }
                }
                catch (err) {
                    console.log(err);
                    mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), 'error');
                }
                if (showWaiter != false) {
                    waitingBS.Hide();
                }
            },
            error: function (xhr, status, error) {
                console.log(error);
                console.log(xhr);
                mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), 'error');
                if ($('#Wishlist_Popup').length > 0) {
                    $('#Wishlist_Popup').dxPopup('instance');
                    popup.hide();
                }
                waitingBS.Hide();
            }
        });
    }
    catch (error) {
        console.log(error);
    }
}

/**
 * Elimina una wishlist.
 * @param {any} idl l'id della wishlist
 */
function EliminaWishlist(idl) {
    try {

        var params = {
            idlista: idl
        };

        $.ajax({
            url: '/Account/RimuoviWishlist',
            type: 'POST',
            data: params,
            success: function (result) {
                try {
                    if (result.esito == Costanti.ESITO_OK) {
                        const popup = $('#Wishlist_Popup').dxPopup('instance');
                        popup.hide();
                        waitingBS.Show();
                        mainController.NotifyMessage(result.responseText, result.NotifyColor);
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                    else {
                        mainController.NotifyMessage(result.responseText, result.NotifyColor);
                        waitingBS.Hide();
                    }
                }
                catch (err) {
                    console.log(err);
                    mainController.NotifyMessage(mainController.GetLabel('lWishlistKoRinomina'), 'error');
                    waitingBS.Hide();
                }
            },
            error: function (xhr, status, error) {
                console.log(error);
                console.log(xhr);
                mainController.NotifyMessage(mainController.GetLabel('lWishlistKoRinomina'), 'error');
                if ($('#Wishlist_Popup').length > 0) {
                    $('#Wishlist_Popup').dxPopup('instance');
                    popup.hide();
                }
                waitingBS.Hide();
            }
        });
    }
    catch (error) {
        console.log(error);
    }
}

/**
 * Rinomina una wishlist.
 * @param {number} idl l'id della wishlist da rinominare.
 * @param {string} nome nuovo nome della wishlist.
 */
function RinominaWishlist(idl, nome) {
    try {

        waitingBS.Show();
        var params = {
            idlista: idl,
            name: nome
        };

        $.ajax({
            url: '/Account/RinominaWishlist',
            type: 'POST',
            data: params,
            success: function (result) {
                try {
                    if (result.esito == Costanti.ESITO_OK) {
                        const popup = $('#Wishlist_Popup').dxPopup('instance');
                        popup.hide();
                        mainController.NotifyMessage(result.responseText, result.NotifyColor);
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                    else {
                        mainController.NotifyMessage(result.responseText, result.NotifyColor);
                    }
                }
                catch (err) {
                    console.log(err);
                    mainController.NotifyMessage(mainController.GetLabel('lWishlistKoRinomina'), 'error');
                }
                waitingBS.Hide();
            },
            error: function (xhr, status, error) {
                console.log(error);
                console.log(xhr);
                mainController.NotifyMessage(mainController.GetLabel('lWishlistKoRinomina'), 'error');
                waitingBS.Hide();
            }
        });
    }
    catch (error) {
        console.log(error);
    }
}

function MoveWishlistToCartBulk(idl, cdc) {
    try {

        waitingBS.Show();
        var params = {
            idlista: idl,
            cdc: cdc
        };

        $.ajax({
            url: '/Account/WishlistAddCartBulk',
            type: 'POST',
            data: params,
            success: function (result) {
                try {
                    if (result.esito == Costanti.ESITO_OK) {
                        const popup = $('#Wishlist_Popup').dxPopup('instance');
                        popup.hide();
                        mainController.NotifyMessage(result.responseText, result.NotifyColor);
                        window.location.href = result.ReturnUrl;
                    }
                    else {
                        mainController.NotifyMessage(result.responseText, result.NotifyColor);
                    }
                }
                catch (err) {
                    console.log(err);
                    mainController.NotifyMessage(mainController.GetLabel('lWishlistKoRinomina'), 'error');
                }
            },
            error: function (xhr, status, error) {
                console.log(error);
                console.log(xhr);
                mainController.NotifyMessage(mainController.GetLabel('lWishlistKoRinomina'), 'error');
                waitingBS.Hide();
            }
        });
    }
    catch (error) {
        console.log(error);
    }
}

/**
 * Rimuove un prodotto dalla wishlist
 * @param {any} idl id della lista della wishlist
 * @param {any} idprod idds del prodotto
 */
function DeleteWishlistProduct(idl, idprod) {
    try {
        waitingBS.Show();
        var params = {
            idlista: idl,
            idds: idprod
        };

        mainController.CallServiceAsync('/Account/RimuoviProdottoWishlist', params)
            .then(function (risp) {
                if (risp.esito == Costanti.ESITO_OK) {
                    var element = document.getElementById('WishlistCard-' + idl + '-' + idprod);
                    if ($(element).length > 0) {
                        element.parentNode.removeChild(element);
                        var ProdottiInLista = $('#numeroProdottiWishlist' + idl);
                        if (parseInt(ProdottiInLista.html()) > 1) {
                            ProdottiInLista.html((parseInt(ProdottiInLista.html()) - 1))
                        }
                        else if (parseInt(ProdottiInLista.html()) == 1) {
                            ProdottiInLista.html('0');
                            $("#ProdottiLista" + idl).html(mainController.GetLabel('lWishlistNoProdotti'));
                            $('#pSpostaWishlistCartBulk' + idl).addClass('hidden');
                            $('#pSpostaWishlistCartBulk' + idl).removeClass('d-flex');
                        }
                    }
                    waitingBS.Hide();
                }
                else {
                    mainController.NotifyMessage(risp.responseText, risp.NotifyColor);
                    waitingBS.Hide();
                }
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
            });
    }
    catch (error) {
        console.log(error);
        waitingBS.Hide();
    }
}

function AggiungiProdottoAWishlist(idl, idprod, prezzo, showWaiter) {
    try {
        if (showWaiter != false) {
            waitingBS.Show();
        }
        var params = {
            idliste: idl,
            idds: idprod,
            price: prezzo
        };

        mainController.CallServiceAsync('/Account/AggiungiProdottoAWishlist', params)
            .then(function (risp) {
                if (risp.esito == Costanti.ESITO_OK) {
                    mainController.NotifyMessage(risp.responseText, risp.NotifyColor);
                }
                else {
                    mainController.NotifyMessage(risp.responseText, risp.NotifyColor);
                }
                const popup = $('#Wishlist_Popup').dxPopup('instance');
                popup.hide();
                if (showWaiter != false) {
                    waitingBS.Hide();
                }
            })
            .catch(function (error) {
                console.log(error);

                const popup = $('#Wishlist_Popup').dxPopup('instance');
                popup.hide();
                waitingBS.Hide();
            });
    }
    catch (error) {
        console.log(error);
        waitingBS.Hide();
    }
}

function GetSelectedCards() {

    var checkboxes = document.querySelectorAll('.wishlist-checkbox');
    var selectedProducts = [];
    checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
            var productId = checkbox.id.split('-')[2];
            selectedProducts.push(productId);
        }
    });
    return selectedProducts;
}

String.prototype.format = function () {
    let formatted = this;
    for (let i = 0; i < arguments.length; i++) {
        let regexp = new RegExp('\\{' + i + '\\}', 'gi');
        formatted = formatted.replace(regexp, arguments[i]);
    }
    return formatted;
};


const DisableContextMenu = function (e) {
    try {
        if (e.target === 'header') e.items = null;

    } catch (error) {
        console.log(error);
    }
}

function CheckAccountExistsStart(username, emailacc) {
    try {
        var user = $('#' + username);
        var email = $('#' + emailacc);
        var check = false;

        if (user == null || user == undefined || user.val().length == 0) {
            user.addClass('is-invalid');
            check = false;
        }
        else {
            check = true;
        }
        if (email == null || email == undefined || email.val().length == 0) {
            email.addClass('is-invalid');
            check = false;
        }
        else if (mainController.CheckEmail(email.val())) {
            check = true;
        }
        else {
            check = false;
            mainController.NotifyMessage(mainController.GetLabel('lemailnonvalida'), 'error');
        }

        if (check) {
            var risp = CheckAccountExists(user.val(), email.val()) == true;
            if (risp == true) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    catch (error) {
        console.log(error);
    }
}

(function ($) {
    $.fn.inputFilter = function (callback, errMsg) {
        return this.on("input keydown keyup mousedown mouseup select contextmenu drop focusout", function (e) {
            if (callback(this.value)) {
                // Accepted value
                if (["keydown", "mousedown", "focusout"].indexOf(e.type) >= 0) {
                    $(this).removeClass("input-error");
                    this.setCustomValidity("");
                }
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                // Rejected value - restore the previous one
                $(this).addClass("input-error");
                this.setCustomValidity(errMsg);
                this.reportValidity();
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                // Rejected value - nothing to restore
                this.value = "";
            }
        });
    };
}(jQuery));

(function () {
    "use strict";

    /**
     * Utilizzate dal tipo37 e 38
     */
    //window.onload = function () {
    //    window.setTimeout(fadeout, 500);
    //}

    //function fadeout() {
    //    document.querySelector('.preloader').style.opacity = '0';
    //    document.querySelector('.preloader').style.display = 'none';
    //}

    /**
     * Easy selector helper function
     */
    const select = (el, all = false) => {
        el = el.trim()
        if (all) {
            return [...document.querySelectorAll(el)]
        } else {
            return document.querySelector(el)
        }
    }

    /**
     * Easy event listener function
     */
    const on = (type, el, listener, all = false) => {
        let selectEl = select(el, all)
        if (selectEl) {
            if (all) {
                selectEl.forEach(e => e.addEventListener(type, listener))
            } else {
                selectEl.addEventListener(type, listener)
            }
        }
    }

    /**
    * Easy on scroll event listener 
    */
    const onscroll = (el, listener) => {
        el.addEventListener('scroll', listener)
    }

    /**
    * Navbar links active state on scroll
    */
    let navbarlinks = select('#navbar .scrollto', true)
    const navbarlinksActive = () => {
        let position = window.scrollY + 200
        navbarlinks.forEach(navbarlink => {
            if (!navbarlink.hash) return
            let section = select(navbarlink.hash)
            if (!section) return
            if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
                navbarlink.classList.add('active')
            } else {
                navbarlink.classList.remove('active')
            }
        })
    }
    window.addEventListener('load', navbarlinksActive)
    onscroll(document, navbarlinksActive)

    /**
    * Scrolls to an element with header offset
    */
    const scrollto = (el) => {
        let header = select('#header')
        let offset = header.offsetHeight

        let elementPos = select(el).offsetTop
        window.scrollTo({
            top: elementPos - offset,
            behavior: 'smooth'
        })
    }

    /**
    * Header fixed top on scroll
    */
    let selectHeader = select('#header')
    if (selectHeader) {
        let headerOffset = selectHeader.offsetTop
        let nextElement = selectHeader.nextElementSibling
        const headerFixed = () => {
            if ((headerOffset - window.scrollY) <= 0) {
                selectHeader.classList.add('fixed-top')
                nextElement.classList.add('scrolled-offset')
            } else {
                selectHeader.classList.remove('fixed-top')
                nextElement.classList.remove('scrolled-offset')
            }
        }
        window.addEventListener('load', headerFixed)
        onscroll(document, headerFixed)
    }

    /**
    * Back to top button
    */
    let backtotop = select('.back-to-top')
    if (backtotop) {
        const toggleBacktotop = () => {
            if (window.scrollY > 100) {
                backtotop.classList.add('active')
            } else {
                backtotop.classList.remove('active')
            }
        }
        window.addEventListener('load', toggleBacktotop)
        onscroll(document, toggleBacktotop)
    }

    /**
    * Mobile nav toggle
    */
    on('click', '.mobile-nav-toggle', function (e) {
        select('#navbar').classList.toggle('navbar-mobile')
        var v = $.trim($(this).text());
        if (v === 'menu')
            $(this).text('close');
        else
            $(this).text('menu');
    })

    /**
     * Mobile nav dropdowns activate
     */
    on('click', '.navbar .dropdown > a', function (e) {
        if (select('#navbar').classList.contains('navbar-mobile')) {
            e.preventDefault()
            this.nextElementSibling.classList.toggle('dropdown-active')
        }
    }, true)


    /**
     * Scrool with ofset on links with a class name .scrollto
     */
    on('click', '.scrollto', function (e) {
        if (select(this.hash)) {
            e.preventDefault()

            let navbar = select('#navbar')
            if (navbar.classList.contains('navbar-mobile')) {
                navbar.classList.remove('navbar-mobile')
                let navbarToggle = select('.mobile-nav-toggle')
                $(navbarToggle).text($(this).text() == 'menu' ? 'close' : 'menu');
                /*navbarToggle.classList.toggle('bi-list')
                navbarToggle.classList.toggle('bi-x')*/
            }
            scrollto(this.hash)
        }
    }, true)

    /**
    * Scroll with ofset on page load with hash links in the url
    */
    window.addEventListener('load', () => {
        if (window.location.hash) {
            if (select(window.location.hash)) {
                scrollto(window.location.hash)
            }
        }
    });

    /**
     * Animation on scroll
     */
    window.addEventListener('load', () => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: true,
            mirror: false
        })
    });
})()

function UpdateEditProfiloForm(model, newUsertype) {
    try {
        waitingBS.Show();

        $.ajax({
            url: '/Account/RefreshFormModificaProfiloUtente',
            type: 'POST',
            data: { model: model, usertype: newUsertype },
            success: function (result) {
                console.log(result.length);
                $("#form-content").html(result);
                waitingBS.Hide();
            },
            error: function (xhr, status, error) {
                console.log(error);
                console.log(xhr);
                waitingBS.Hide();
            }
        });
    }
    catch (error) {
        console.log(error);
        waitingBS.Hide();
    }
}

function smellsLikeIban(str) {
    return /^([A-Z]{2}[ \-]?[0-9]{2})(?=(?:[ \-]?[A-Z0-9]){9,30}$)((?:[ \-]?[A-Z0-9]{3,5}){2,7})([ \-]?[A-Z0-9]{1,3})?$/.test(str);
}

function validateIbanChecksum(iban) {
    const ibanStripped = iban.replace(/[^A-Z0-9]+/gi, '') //keep numbers and letters only
        .toUpperCase(); //calculation expects upper-case
    const m = ibanStripped.match(/^([A-Z]{2})([0-9]{2})([A-Z0-9]{9,30})$/);
    if (!m) return false;

    const numbericed = (m[3] + m[1] + m[2]).replace(/[A-Z]/g, function (ch) {
        //replace upper-case characters by numbers 10 to 35
        return (ch.charCodeAt(0) - 55);
    });
    //The resulting number would be to long for javascript to handle without loosing precision.
    //So the trick is to chop the string up in smaller parts.
    const mod97 = numbericed.match(/\d{1,7}/g)
        .reduce(function (total, curr) { return Number(total + curr) % 97 }, '');

    return (mod97 === 1);
}

/**
* Effettua la validazione del form di modifica
* @param {any} lcid
*/
function UpdateUser(lcid, idIndirizzo) {
    waitingBS.Show();

    try {
        var formstate = true;
        var scroll = true;
        var usertype = parseInt($("#reg-tipologiaprofiloutente").val());

        $("form#feditprofilo :input").each(function (index, value) {
            $(this).removeClass('is-invalid');
            if (!$(this)[0].closest("#panel-spedizione") || ($(this)[0].closest("#panel-spedizione") && $("#cbshippingsameaddress")[0].checked)) {
                if ($(this).attr('required') && ($(this)[0].disabled == false || !$(this).attr('disabled'))) {
                    if ($(this).val() == null || $(this).val() == undefined || $(this).val() == '') {
                        $(this).addClass('is-invalid');
                        console.log(this.id + ' invalid');
                        formstate = false;
                    }
                }
            }
        });

        var titolo = $('#reg-titolo');
        if (titolo == null || titolo == undefined || titolo.val() == '' || parseInt(titolo.val()) == 0) {
            titolo.addClass('is-invalid');
            formstate = false;
        }

        /* Controllo partita IVA */
        var piva = $('#reg-piva');
        var gruppoIva = $('#reg-isGruppoIva').val()?.toLowerCase() == 'true';
        if (piva) {
            if (piva.attr('required') || (!piva.attr('required') && piva.val())) {
                if (lcid == 1040) {
                    if (CheckPartitaIvaReg(piva.val(), $("#reg-cf").val()?.trim(), gruppoIva) == false) {
                        formstate = false;
                    }
                }
                else if (lcid == 1034) {
                    var valorePiva = piva.val().trim();
                    if (ESDoc(valorePiva) == false) {
                        piva.addClass('is-invalid');
                        formstate = false;
                    }
                }
            }
        }
        else {
            piva.addClass('is-invalid');
            formstate = false;
        }

        /* Fatturazione Elettronica */
        var pFattEle = $('#panel-fattele');
        if (pFattEle.length > 0) {
            var pec = $("#reg-fpec");
            var sdi = $("#reg-fsdi");
            if (pFattEle.attr('required')) {
                if (!sdi.val() && !pec.val()) {
                    sdi.addClass('is-invalid');
                    pec.addClass('is-invalid');
                    $("#msgsdi").html(mainController.GetLabel('lErroreFattElettronica'));
                    $("#msgpec").html('');
                    formstate = false;
                }
                else {
                    if (sdi.val()) {
                        if (CheckSdi(sdi, usertype) == false) {
                            formstate = false;
                        }
                    }
                    if (pec.val()) {
                        if (mainController.CheckEmail(pec.val()) == false) {
                            pec.addClass('is-invalid');
                            $("#msgpec").html(mainController.GetLabel('lErrorePEC'));
                            formstate = false;
                        }
                        else {
                            pec.removeClass('is-invalid');
                            $("#msgpec").html('');
                        }
                    }
                }
            }
            else {
                if (sdi.val()) {
                    if (CheckSdi(sdi, usertype) == false) {
                        formstate = false;
                    }
                }
                if (pec.val()) {
                    if (mainController.CheckEmail(pec.val()) == false) {
                        pec.addClass('is-invalid');
                        $("#msgpec").html(mainController.GetLabel('lErrorePEC'));
                        formstate = false;
                    }
                    else {
                        pec.removeClass('is-invalid');
                        $("#msgpec").html('');
                    }
                }
            }
        }

        /* Controllo nazione */
        var fnazione = $('#reg-fnazione');
        if (!fnazione.val() || fnazione.val() == '0' || fnazione.val() == '') {
            fnazione.addClass('is-invalid');
            formstate = false;
        }

        /* Controllo provincia */
        if (CheckCittaEProvincia(lcid, idIndirizzo) == false) {
            formstate = false;
        }


        /* Controllo Codice fiscale */
        var cf = $("#reg-cf");
        if ((cf.prop('required') == true || cf.val()?.trim()?.length > 0 == true) && ((gruppoIva == true && cf.hasClass('is-invalid') == false) || gruppoIva == false)) {
            if (CheckCodiceFiscaleReg(usertype, cf.val().trim(), lcid) == false) {
                cf.addClass('is-invalid');
                formstate = false;
            }
            else {
                cf.removeClass('is-invalid');
            }
        }


        /* Controllo del CAP */
        if (CheckCapReg($("#reg-fcap"), lcid, $('#errorefcap')) == false) {
            formstate = false;
        }

        /* check recapito telefonico fatturazione */
        var ftel = $('#reg-ftelefono').val().trim();
        var fcel = $('#reg-fcellulare').val().trim();

        if (ftel === '' && fcel === '') {
            $('#reg-ftelefono').addClass('is-invalid');
            $('#reg-fcellulare').addClass('is-invalid');
            $('#chkfrecapito').html(mainController.GetLabel('lAvvisoRecapito'));
            formstate = false;
        }
        else {
            $('#reg-ftelefono').removeClass('is-invalid');
            $('#reg-fcellulare').removeClass('is-invalid');
            $('#chkfrecapito').html('');

            if (ftel.length > 0) {
                var risPref = CheckPrefisso('select_prefisso_tel_fatt');
                if (risPref != true) {
                    formstate = false;
                }
            }
            else {
                var risPref = CheckPrefisso('select_prefisso_cell_fatt');
                if (risPref != true) {
                    formstate = false;
                }
            }
        }

        if (formstate == true) {
            try {
                if ($('#listspecialita').length > 0) {
                    var specialita = $('#listspecialita').dxList('instance')?.option('selectedItemKeys');
                    if (specialita) {
                        if (specialita.length == 0) {
                            waitingBS.Hide();
                            mainController.NotifyMessage(mainController.GetLabel('lErroreSpecialitaScelta'), 'error');
                            return false;
                        }
                    }
                }
                return true;
            }
            catch (error) {
                console.log(error);
                return true;
            }
        }
        else {
            waitingBS.Hide();
            if (scroll) {
                $(window).scrollTop(0);
            }
            return false;
        }
    } catch (e) {
        waitingBS.Hide();
        $(window).scrollTop(0);
        console.log(e);
        return false;
    }
}


function CheckPrefisso(idLookup) {
    var lookupPrefisso = $('#' + idLookup).dxLookup('instance');
    if (!lookupPrefisso.option('value')) {
        lookupPrefisso.option('isValid', false);
        return false;
    }
    else {
        lookupPrefisso.option('isValid', true);
    }
    return true;
}

/**
* Controlla lo SDI della registrazione tenendo conto dello usertype selezionato
* @param {any} sdi
* @param {any} usertype
* @returns {boolean}
*/
function CheckSdi(sdi, usertype) {
    try {
        if (!((sdi.val().length == 7 && usertype != 4) || (sdi.val().length == 6 && usertype == 4)/* P.A. */)) {
            sdi.addClass('is-invalid');
            $("#msgsdi").html(mainController.GetLabel('lErroreSDILunghezza'));
            return false;
        }
        else if (sdi.val() == '0000000') {
            sdi.addClass('is-invalid');
            $("#msgsdi").html(mainController.GetLabel('lErroreSDIZero'));
            return false;
        }
        else {
            sdi.removeClass('is-invalid');
            $("#msgsdi").html('');
            return true;
        }
    }
    catch (error) {
        console.log(error);
        return false;
    }
}

/**
* Visualizza/Nasconde un elemento html
* @param {string} divId - id del controllo da visualizzare/nascondere
* */
function toggler(divId) {
    $("#" + divId).fadeToggle("slow", "swing");

    var isSpedDiversa = $('#reg-isspedizionediversa');
    if (isSpedDiversa.length > 0) {
        isSpedDiversa.val($('#cbshippingsameaddress')[0].checked);
    }
}

/**
* Copia i campi dell'indirizzo di fattuazione in quello di spedizione.
*/
function copyaddress(forced, lcid) {
    if ($("#cbshippingsameaddress").checked || forced) {

        $("#reg-sindirizzo").val($("#reg-findirizzo").val());
        $("#reg-scap").val($("#reg-fcap").val());
        $("#reg-snazione").val($("#reg-fnazione").val());
        $("#reg-stelefono").val($("#reg-ftelefono").val());
        $("#reg-scellulare").val($("#reg-fcellulare").val());
        $("#reg-sragsoc").val($("#reg-fragionesociale").val());
        $("#reg-snome").val($("#reg-fnome").val())
        $("#reg-scognome").val($("#reg-fcognome").val())

        $('#select_prefisso_tel_sped').dxLookup('instance').option('value', $('#select_prefisso_tel_fatt').dxLookup('instance').option('value'));
        $('#select_prefisso_cell_sped').dxLookup('instance').option('value', $('#select_prefisso_cell_fatt').dxLookup('instance').option('value'));

        switch (lcid) {
            case 1034:
            case 1040:
                if ($('#reg-sprovincia') && $('#reg-fprovincia').length > 0) {
                    $('#reg-sprovincia').dxSelectBox('instance').option('value', $('#reg-fprovincia').dxSelectBox('instance').option('value'));
                }
                else if ($('#reg-sprovincia0') && $('#reg-fprovincia0').length > 0) {
                    $('#reg-sprovincia0').dxSelectBox('instance').option('value', $('#reg-fprovincia0').dxSelectBox('instance').option('value'));
                }
                break;
            default:
                if ($('#reg-sprovincia') && $('#reg-fprovincia').length > 0) {
                    $("#reg-sprovincia").val($("#reg-fprovincia").val())
                }
                else if ($('#reg-sprovincia0') && $('#reg-fprovincia0').length > 0) {
                    $("#reg-sprovincia0").val($("#reg-fprovincia0").val())
                }
                break;
        }

        if (lcid == 1034) {
            if ($('#reg-scitta') && $('#reg-fcitta').length > 0) {
                $('#reg-scitta').dxSelectBox('instance').option('value', $('#reg-fcitta').dxSelectBox('instance').option('value'));
            }
            else if ($('#reg-scitta0') && $('#reg-fcitta0').length > 0) {
                $('#reg-scitta0').dxSelectBox('instance').option('value', $('#reg-fcitta0').dxSelectBox('instance').option('value'));
            }
        }
        else {
            if ($('#reg-scitta') && $('#reg-fcitta').length > 0) {
                $("#reg-scitta").val($("#reg-fcitta").val())
            }
            else if ($('#reg-scitta0') && $('#reg-fcitta0').length > 0) {
                $("#reg-scitta0").val($("#reg-fcitta0").val())
            }
        }
    }
}

/* Pagina Catalogo */

/**
 * Mostra tutte le sottocategorie di una categorie che ha più di 2 righe di sottocategorie
 * @param {string} idcat l'id della categoria
 */
function showmorecategories(idcat) {
    waitingBS.Show();
    var params = {
        idc: idcat,
        mostracategorie: true
    };

    $.ajax({
        url: '/GetGridCategorie',
        type: 'POST',
        data: params,
        success: function (result) {
            $("#grigliacategoriecatalogo").html(result);
            $("#btnShowMoreCats").addClass("hidden");
        },
        error: function (xhr, status, error) {
            console.log(error);
            console.log(xhr);
        }
    });

    waitingBS.Hide();
}
/* Form Contatti */
function FCshow() {
    try {
        var ddlRichiesta = $("#ddlRichiesta");
        var ddlOggetti1 = $("#ddlOggetti1");
        var ddlOggetti2 = $("#ddlOggetti2");
        var select1 = $("#select1");
        var select2 = $("#select2");
        var txtMessaggio = $("#txtMessaggio")
        var divProd = $("#divProd")
        var divOrdine = $("#divOrdine")
        var divNomeAzienda = $("#divNomeAzienda")

        switch (ddlRichiesta.val()) {
            case '': // -seleziona-
                select1.addClass("hidden");
                select2.addClass("hidden");
                txtMessaggio.addClass("hidden");
                divOrdine.addClass("hidden");
                divNomeAzienda.addClass('hidden');
                return;
            case '0': // vorrei ordinare
                select1.removeClass("hidden");
                select2.addClass("hidden");
                txtMessaggio.addClass("hidden");
                divNomeAzienda.addClass('hidden');

                switch (ddlOggetti1.val()) {
                    case '': // -seleziona-
                        select2.addClass("hidden");
                        divProd.addClass("hidden");
                        divOrdine.addClass("hidden");
                        txtMessaggio.addClass("hidden");
                        return;
                    case '0': //richiesta preventivo
                    case '2': //come ordinare
                        select2.addClass("hidden");
                        divProd.addClass("hidden");
                        divOrdine.addClass("hidden");
                        txtMessaggio.removeClass("hidden");
                        return;
                    case '1': //informazioni sui prodotti
                        select2.addClass("hidden");
                        divProd.removeClass("hidden");
                        divOrdine.addClass("hidden");
                        txtMessaggio.removeClass("hidden");
                        return;
                }
                return;
            case '1': //ho già ordinato ma ho bisogno di assistenza
                select1.addClass("hidden");
                select2.removeClass("hidden");
                divProd.addClass("hidden");
                divOrdine.addClass("hidden");
                txtMessaggio.addClass("hidden");
                divNomeAzienda.removeClass('hidden');

                switch (ddlOggetti2.val()) {
                    case '': // -seleziona-
                        select1.addClass("hidden");
                        divProd.addClass("hidden");
                        divOrdine.addClass("hidden");
                        txtMessaggio.addClass("hidden");
                        return;
                    default: //sono tutti con la richiesta dell'id dell'ordine
                        select1.addClass("hidden");
                        divProd.addClass("hidden");
                        divOrdine.removeClass("hidden");
                        txtMessaggio.removeClass("hidden");
                        return;
                }
                return;
            case '2': //altro
                select1.addClass("hidden");
                select2.addClass("hidden");
                divProd.addClass("hidden");
                divOrdine.addClass("hidden");
                divNomeAzienda.addClass('hidden');
                txtMessaggio.removeClass("hidden");
                return;
            case '3': //richiesta di voler vendere
                select1.addClass("hidden");
                select2.addClass("hidden");
                txtMessaggio.removeClass("hidden");
                divNomeAzienda.removeClass('hidden');
                return;
            default:
                console.log('Richiesta non gestita');
        }
    }
    catch (error) {
        console.log(error);
    }
}
function FCValidation() {
    try {
        var formstate = true;
        var textarea = $("form#fcontatti textarea")[0];

        $("form#fcontatti input").each(function () {
            var input = $(this)[0];
            if (!input.parentNode.classList.contains('hidden')) {
                var attr = $(this).attr('required');
                if (typeof attr !== 'undefined') {
                    if (input.value == '' || input.classList.contains('is-invalid')) {
                        input.classList.add('is-invalid');
                        formstate = false;
                    }
                }
            }
        });

        if (!mainController.CheckEmail($("#fcEmail").val())) {
            $("#fcEmail").addClass('is-invalid');
            formstate = false;
        }
        $("form#fcontatti select").each(function () {
            var input = $(this)[0];
            if (!input.parentNode.classList.contains('hidden')) {
                var attr = $(this).attr('required');
                if (typeof attr !== 'undefined') {
                    if (input.value == '' || input.classList.contains('is-invalid')) {
                        input.classList.add('is-invalid');
                        formstate = false;
                    }
                }
            }
        });

        if (!textarea.parentNode.classList.contains('hidden')) {
            if (textarea.value == '' || textarea.classList.contains('is-invalid')) {
                textarea.classList.add('is-invalid');
                formstate = false;
            }
        }

        try {
            const recaptcha_box_checked = (grecaptcha.getResponse()) ? true : false;

            if (recaptcha_box_checked == false) {
                formstate = false;
                mainController.NotifyMessage(mainController.GetLabel('lErroreCaptchaVuoto'), 'error');
            }
        }
        catch (error) {
            console.log(error);
            formstate = false;
        }

        if ($('#divPrivacy') && $('#divPrivacy').length > 0) {
            if (document.getElementById('cbPrivacy').checked == false) {
                $('#erroreInformativa').removeClass('hidden');
                formstate = false;
            }
            else {
                $('#erroreInformativa').addClass('hidden');
            }
        }

        if (formstate == false) {
            return false;
        }
        else {
            try {
                waitingBS.Show();

                var params = new FormData($("form#fcontatti")[0]);

                mainController.CallServiceFormDataAsync($('form#fcontatti').attr('action'), params)
                    .then(risp => {

                        if (risp.esito == Costanti.ESITO_OK) {
                            $('#FormContatti').html(mainController.GetLabel(risp.responseText));
                        }
                        else {
                            mainController.NotifyMessage(mainController.GetLabel(risp.responseText), risp.NotifyColor);
                        }
                        $(window).scrollTop(0);
                        waitingBS.Hide();
                    })
                    .catch(error => {
                        console.log(error);
                        waitingBS.Hide();
                    });
            }
            catch (error) {
                console.log(error);
                waitingBS.Hide();
            }
            return false;
        }
    }
    catch (error) {
        console.log(error);
    }
}

function ShowAllDesc(part1, label) {
    $("#" + part1 + " .descrizione").removeClass("descrizione");
    label.classList.add("hidden");
}

/**
 * Metodo che permette di cancellare una riga di una griglia devextreme tramite un popup '#ConfirmDeletionPopup'.
 * @param {any} hkey il nome di un campo input al cui interno c'è il valore della RowKey da eliminare.
 * @param {any} hgrid il nome della griglia su cui agire.
 */
function CancellaRiga(hkey, hgrid) {
    try {
        if (hkey && hgrid) {
            var key = $('#' + hkey).val();
            if (key.length > 0) {
                var grid = $('#' + hgrid).val();
                if (grid) {
                    var dataGrid = $('#' + grid).dxDataGrid('instance');
                    if (dataGrid) {
                        var index = dataGrid.getRowIndexByKey(parseInt(key));
                        dataGrid.deleteRow(index);

                        $('#ConfirmDeletionPopup').dxPopup('instance').hide();
                    }
                    else {
                        console.log('griglia non trovata');
                    }
                }
                else {
                    console.log('grid name non trovato');
                }
            }
            else {
                console.log('grid key non trovata');
            }
        }
        else {
            console.log('hkey: ' + typeof (hkey) + ', hgrid: ' + typeof (hgrid));
        }
    }
    catch (error) {
        console.log(error);
    }
}

var paginaOrdini = 0;
/**
 * Metodo usato per aggiornare la pagina da cercare nella paginazione dello storico degli ordini.
 * @param {number} pagina La pagina da cercare.
 * @param {number} anno L'anno da usare per la ricerca.
 */
function AggiornaOrderHistory(pagina, anno) {
    paginaOrdini = pagina;
    AggiornaOrdini();
}

/**
 * Metodo che aggiorna lo storico degli ordini cambiando l'anno o usando la paginazione.
 * @param {number} anno L'anno da usare per la ricerca.
 */
function AggiornaOrdini(anno) {
    waitingBS.Show();

    if (!anno) {
        anno = $('#AnnoOrdini')?.val();
    }

    var params = {
        year: anno,
        pagina: paginaOrdini
    };

    if (params.pagina < 0) {
        params.pagina = 0;
    }
    try {

        $.ajax({
            url: '/Account/GetElencoOrdini',
            type: 'POST',
            data: params,
            success: function (result) {
                $('#gridOrdini').html(result);
                $('#anno').html(anno);
                $(window).scrollTop(0);
                waitingBS.Hide();
            },
            catch: function (error) {
                console.log(error);
                mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), 'error')
                waitingBS.Hide();
            }
        });
    }
    catch (error) {
        console.log(error);
        waitingBS.Hide();
    }
}

/**
 * Metodo che cerca un ordine nello storico degli ordini
 * i campi di ricerca sono stati nascosti perché la ricerca non va insieme alla paginazione
 */
function SearchOrder() {
    let input = $("#Ricerca").val();
    input = input.toLowerCase();
    let divListe = $('[id^="CardOrdine_"]');

    for (i = 0; i < divListe.length; i++) {
        if (!divListe[i].innerHTML.toLowerCase().includes(input.toLowerCase())) {
            divListe[i].closest('[id^="CardOrdine_"]').style.display = "none";
        }
        else {
            divListe[i].closest('[id^="CardOrdine_"]').style.display = "";
        }
    }
}


function CheckIndirizzoSpedizione() {

    var Validation = true;

    try {
        var divOrdiniRip = $('#divOrdiniRipetitivi');
        if (divOrdiniRip && divOrdiniRip.length > 0) {
            var cbData = $('#cbData').dxCheckBox('instance');
            var dbData = $('#dbDataDesiderata').dxDateBox('instance');
            var dbDataValue = dbData.option('value');
            var hData = $('#hDataDesiderata');

            if (cbData.option('value') == true) {
                //f ((!dbDataValue || dbDataValue == '01/01/0001 00:00:00') && (!hData.val() || !hData.val()))
                if (!dbDataValue || dbDataValue == '01/01/0001 00:00:00') {
                    hData.val(dateformat(cbData.option('min')));
                    dbData.option("isValid", false);
                    Validation = false;
                }
            }

            var cbRip = $('#cbRipetitivo').dxCheckBox('instance');
            var intervallo = $('#ddlIntervallo');
            var frequenza = $('#ddlFrequenza');
            var ripetizioni = $('#ddlRipetizioni');

            if (cbRip.option('value') == true) {
                if (!intervallo.val() || intervallo.val() == '0' || intervallo.val() == 0) {
                    intervallo.addClass('is-invalid');
                    Validation = false;
                }
                else {
                    intervallo.removeClass('is-invalid');
                }

                if (!frequenza.val()) {
                    frequenza.addClass('is-invalid');
                    Validation = false;
                }
                else {
                    frequenza.removeClass('is-invalid');
                }

                if (!ripetizioni.val() || parseInt(ripetizioni.val()) < 2) {
                    ripetizioni.addClass('is-invalid');
                    Validation = false;
                }
                else {
                    ripetizioni.removeClass('is-invalid');
                }


            }

        }
    } catch (error) {
        console.log(error);
    }

    if (Validation == true) {
        var value = $("#listaddress").dxSelectBox('instance').option('value');
        if (!value) {
            mainController.NotifyMessage(mainController.GetLabel('lSelezionaIndirizzoSped'), "error");
            return false;
        }
        else {
            return true;
        }
    }
    else {
        return false;
    }
}

function SetDataDesiderata(data) {
    $('#hDataDesiderata').val(dateformat(data.value));

    $('#dbUltimoOrdine').dxDateBox('instance').option('min', data.value);

    CalcolaDataUltimoOrdine();
}

function gridContainer_RowPrepared(e) {
    try {

        if (e.rowType == 'data') {
            if (e.data.Stato == Costanti.STATO_ORDINE_RIPETITIVO
                || e.data.Stato == Costanti.STATO_ORDINE_RIPETITIVO_APPROVAZIONE1
                || e.data.Stato == Costanti.STATO_ORDINE_RIPETITIVO_APPROVAZIONE2) {

                e.rowElement[0].classList.remove('dx-row-alt');
                e.rowElement[0].style.backgroundColor = 'rgb(206 238 247)';
            }
            else if ((e.data.Stato == Costanti.STATO_ORDINE_POSTICIPATO
                || e.data.Stato == Costanti.STATO_ORDINE_POSTICIPATO_APPROVAZIONE1
                || e.data.Stato == Costanti.STATO_ORDINE_POSTICIPATO_APPROVAZIONE2)
                && e.data.StatoDescrizione.includes(' - ') == false) {
                //console.log(e);
                e.rowElement[0].classList.remove('dx-row-alt');
                e.rowElement[0].style.backgroundColor = 'rgb(200 245 214)';
            }
        }

    } catch (error) {
        console.log(error);
    }
}

function cbData_ValueChanged(e) {
    try {

        if (e.value == true) {
            $('#divData').show();
            $('#divCbRip').show();
            var dateMin = $('#dbDataDesiderata').dxDateBox('instance').option('min');
            var dateVal = $('#dbDataDesiderata').dxDateBox('instance').option('value');
            if (dateMin < dateVal) {
                $('#hDataDesiderata').val(dateformat(dateVal));
            }
            else {
                $('#hDataDesiderata').val(dateformat(dateMin));
            }
        }
        else {
            $('#cbRipetitivo').dxCheckBox('instance').option('value', false);
            $('#divData').hide();
            $('#divCbRip').hide();
            $('#hDataDesiderata').val('');

            var dateboxData = $('#dbDataDesiderata').dxDateBox('instance');

            dateboxData.option('value', null);
            dateboxData.option('isValid', true);
            dateboxData.option('validationStatus', 'valid');
        }

    } catch (error) {
        console.log(error);
    }
}
function cbRipetitivo_ValueChanged(e) {
    try {

        if (e.value == true) {
            $('#tableRipetitivo').show();
        }
        else {
            $('#tableRipetitivo').hide();

            $('#ddlIntervallo').val('0');
            document.getElementsByName('DatiFrequenzaOrdine.Intervallo')[0].value = $('#ddlIntervallo').val();
            $('#ddlFrequenza').val('');
            document.getElementsByName('DatiFrequenzaOrdine.Frequenza')[0].value = $('#ddlFrequenza').val();
            $('#ddlRipetizioni').val('2');
            document.getElementsByName('DatiFrequenzaOrdine.Ripetizioni')[0].value = $('#ddlRipetizioni').val();

            var dateboxData = $('#dbUltimoOrdine').dxDateBox('instance');

            dateboxData.option('value', null);
            dateboxData.option('isValid', true);
            dateboxData.option('validationStatus', 'valid');
        }

    } catch (error) {
        console.log(error);
    }
}

function ddl_ValueChanged(e) {
    try {

        ClearClass(e, 'is-invalid');
        document.getElementsByName('DatiFrequenzaOrdine.' + e.id.replace('ddl', ''))[0].value = e.value;

        updateRipetizioni = true;
        CalcolaDataUltimoOrdine();
        //updateRipetizioni = false;

    } catch (error) {
        console.log(error);
    }
}

function CalcolaDataUltimoOrdine() {
    try {

        var intervallo = $('#ddlIntervallo');
        var frequenza = $('#ddlFrequenza');
        var ripetizioni = $('#ddlRipetizioni');

        if (intervallo.val() && frequenza.val() && ripetizioni.val()) {

            var dateOrdini = CalcolaDate(intervallo.val(), frequenza.val(), ripetizioni.val());
            var dataFinale = dateOrdini[dateOrdini.length - 1];

            $('#dbUltimoOrdine').dxDateBox('instance').option('value', dataFinale);
        }

    } catch (error) {
        console.log(error);
    }
}

var updateRipetizioni = false;

function dbUltimoOrdine_ValueChanged() {
    try {
        if (updateRipetizioni == false) {
            var intervallo = $('#ddlIntervallo');
            var frequenza = $('#ddlFrequenza');
            var ripetizioni = $('#ddlRipetizioni');
            var dataUtlimoOrd = $('#dbUltimoOrdine').dxDateBox('instance');
            var dataStart = $('#dbDataDesiderata').dxDateBox('instance').option('min');
            var contMax = 0;

            if (intervallo.val() && frequenza.val() && dataUtlimoOrd.option('value')) {
                var trovato = false;
                var nuoveRipetizioni = 0;

                while (trovato == false) {

                    cont++;

                    if (cont < 500) {
                        if (frequenza.val() == '0') { // Giorni
                            dataStart = addDays(dataStart, parseInt(intervallo.val()));
                        }
                        else if (frequenza.val() == '1') { // Settimane
                            dataStart = addDays(dataStart, parseInt(intervallo.val()) * 7);
                        }
                        else if (frequenza.val() == '2') { // Mesi
                            // Ottieni il numero di giorni nel nuovo mese
                            let daysInNewMonth = getDaysInMonth(dataStart);

                            dataStart = addDays(dataStart, parseInt(intervallo.val()) * daysInNewMonth);
                        }
                        else {
                            return;
                        }

                        nuoveRipetizioni++;

                        if (dataStart >= dataUtlimoOrd.option('value')) {
                            trovato = true;
                            if (dataStart > dataUtlimoOrd.option('value')) {
                                nuoveRipetizioni--;
                            }
                        }
                    }
                }

                if (nuoveRipetizioni != ripetizioni.val() && nuoveRipetizioni > 1 && nuoveRipetizioni <= 30) {
                    ripetizioni.val('' + nuoveRipetizioni);
                    ddl_ValueChanged(ripetizioni[0]);
                }

                if (nuoveRipetizioni > 2 && nuoveRipetizioni <= 30) {
                    ripetizioni.removeClass('is-invalid');
                }
                else {
                    ripetizioni.addClass('is-invalid');
                }
            }
        }

        updateRipetizioni = false;

    } catch (error) {
        console.log(error);
    }
}

function CalcolaDate(intervallo, frequenza, ripetizioni) {
    let dates = [];
    let currentDate = $('#dbDataDesiderata').dxDateBox('instance').option('value');

    if (!currentDate || (currentDate && currentDate == '01/01/0001 00:00:00')) {
        currentDate = $('#dbDataDesiderata').dxDateBox('instance').option('min');
    }

    if (frequenza && intervallo > 0 && ripetizioni > 0) {
        for (let i = 0; i < ripetizioni; i++) {

            dates.push(new Date(currentDate));

            if (frequenza == '0') { // Giorni
                currentDate = addDays(currentDate, parseInt(intervallo));
            }
            else if (frequenza == '1') { // Settimane
                currentDate = addDays(currentDate, parseInt(intervallo) * 7);
            }
            else if (frequenza == '2') { // Mesi
                // Ottieni il numero di giorni nel nuovo mese
                let daysInNewMonth = getDaysInMonth(currentDate);

                currentDate = addDays(currentDate, parseInt(intervallo) * daysInNewMonth);
            }
        }
    }

    return dates;
}

function QuotValidation(qtaMinima) {
    var risp = true;

    try {

        var tbQta = $('#tbQta');
        var tbEmail = $('#tbEmail');

        if (!tbQta.val() || (tbQta.val() && parseInt(tbQta.val()) < qtaMinima)) {
            tbQta.addClass('is-invalid');
            risp = false;
        }
        else {
            tbQta.removeClass('is-invalid');
        }

        if (!tbEmail.val() || (tbEmail.val() && !mainController.CheckEmail(tbEmail.val()))) {
            tbEmail.addClass('is-invalid');
            risp = false;
        }
        else {
            tbEmail.removeClass('is-invalid');
        }
    }
    catch (error) {
        console.log(error);
        risp = false;
    }
    return risp;
}

function fQuotazione_Submit() {
    try {

        $('#fQuotazione').submit(function (e) {
            e.preventDefault();

            var tbQta = $('#tbQta');
            var tbEmail = $('#tbEmail');
            var tbNote = $('#tbNote');
            var tbIDDS = $('#tbIDDS');
            waitingBS.Show();

            var params = {
                request: {
                    Quantita: tbQta.val(),
                    Email: tbEmail.val(),
                    Note: tbNote.val(),
                    IDDS: tbIDDS.val()
                }
            }

            $.ajax({
                url: $('#fQuotazione').attr('action'),
                type: 'POST',
                DataType: 'json',
                data: params,
                success: function (risp) {

                    waitingBS.Hide();
                    mainController.NotifyMessageTimed(risp.responseText, risp.NotifyColor, 4500);

                    if (risp.esito == Costanti.ESITO_KO) {
                        tbQta.val('');
                        tbEmail.val('');
                        tbNote.val('');

                        const popupQuot = $('#popupQuotazione').dxPopup('instance');
                        popupQuot.hide();

                    }
                },
                error: function (error) {
                    console.log(error);

                    waitingBS.Hide();
                    mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico', Costanti.NOTIFY_COLOR_ERROR));
                }
            });
        })

    } catch (error) {
        console.log(error);
        waitingBS.Hide();
        mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico', Costanti.NOTIFY_COLOR_ERROR));
    }
}


function RiempiConsensi(ConsensoMkt, ConsensoProf) {
    if (ConsensoMkt) {
        $('#regmktg1').val("true");
        $('#regmktg1').attr("checked", "true");
        $('#regmktg2').val("false");
    }
    else {
        $('#regmktg1').val("false");
        $('#regmktg2').val("true");
        $('#regmktg2').attr("checked", "true");

    }
    if (ConsensoProf) {
        $('#regprof1').val("true");
        $('#regprof1').attr("checked", "true");
        $('#regprof2').val("false");
    }
    else {
        $('#regprof1').val("false");
        $('#regprof2').val("true");
        $('#regprof2').attr("checked", "true");

    }

    if (ConsensoProf != null) {
        $('#chkp3').html('');
    }
    if (ConsensoMkt != null) {
        $('#chkp2').html('');
    }
}
function FormResetPassword(primoAccesso, token, Email, controllerName, AccountId, idsito) {
    try {
        var password = $('#rec-password');
        var cpassword = $('#rec-cpassword');
        var chkpassword = $('#chkpassword');

        var result = true;
        if (primoAccesso == 'True') {
            var sceltaNewsletter = $('#sceltaNewsletter').val();
            var erroreNewsletter = $('#lErroreNews');

            //var sceltaProfilazione = $('#sceltaProfilazione').val();
            //var erroreProfilazione = $('#lErroreProf');


            if (sceltaNewsletter == null || sceltaNewsletter == undefined || sceltaNewsletter == '') {
                erroreNewsletter.addClass('is-invalid');
                result = false;
            }
            else {
                erroreNewsletter.removeClass('is-invalid');
            }

            //if (sceltaProfilazione == null || sceltaProfilazione == undefined || sceltaProfilazione == '') {
            //    erroreProfilazione.addClass('is-invalid');
            //    result = false;
            //}
            //else {
            //    erroreProfilazione.removeClass('is-invalid');
            //}
        }

        if (result == true) {
            if (CheckPassword(password, cpassword, chkpassword, idsito) == true) {

                waitingBS.Show();
                mainController.CallServiceAsync('/Account/ControllaPasswordPrecedente', { password: password.val(), idacc: AccountId })
                    .then(passOK => {
                        if (passOK == true) {

                            var params = {
                                lr: {
                                    token: token,
                                    password: password.val(),
                                    email: Email,
                                    controllerName: controllerName,
                                    accountId: AccountId,
                                    ACCO_PrimoAccesso: primoAccesso,
                                    ACCO_ConsensoNewsletter: sceltaNewsletter
                                }
                            };

                            mainController.CallServiceAsync('/Account/ResetPassword', params)
                                .then(risp => {
                                    if (risp.esito == Costanti.ESITO_OK) {
                                        mainController.NotifyMessageTimed(risp.responseText, risp.NotifyColor, 5000);

                                        setTimeout(() => {
                                            window.location.href = risp.ReturnUrl;
                                        }, 3000);
                                    }
                                    else if (risp) {
                                        mainController.NotifyMessageTimed(risp.responseText, risp.NotifyColor);
                                        waitingBS.Hide();
                                    }
                                    else {
                                        mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), Costanti.NOTIFY_COLOR_ERROR);
                                        waitingBS.Hide();
                                    }
                                })
                                .catch(error => {
                                    console.log(error);
                                    mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), Costanti.NOTIFY_COLOR_ERROR);
                                    waitingBS.Hide();
                                });
                        }
                        else {
                            mainController.NotifyMessage(mainController.GetLabel('ErrorePasswordPrecedente'), Costanti.NOTIFY_COLOR_ERROR);
                            waitingBS.Hide();
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), Costanti.NOTIFY_COLOR_ERROR);
                        waitingBS.Hide();
                    })
            }
        }
        return false;
    }
    catch (error) {
        console.log(error);
        waitingBS.Hide();
        return false;
    }
}
function ModificaConsensi(ConsensoBase, ConsensoServizio) {
    //var ConsensoResgitrazione = $('#regsrv1').val();
    //if (ConsensoResgitrazione == "true" || ConsensoResgitrazione == "on") {

    var sceltaRegMktg = $('#sceltaRegMktg').val();// questa vieni riempiada quando il cliente cambia la scelta
    var ConsensoMktg = $('#regmktg1').val(); // recupera consenso accetto
    var cbMktg = "";// il valore che passo nella chiamata

    var sceltaRegProf = $('#sceltaRegProf').val();
    var ConsensoProf = $('#regprof1').val();
    var cbProf = "";

    if (sceltaRegMktg == null || sceltaRegMktg == undefined || sceltaRegMktg == '') {
        if (ConsensoMktg == "true") {
            cbMktg = "true";
        }
        else {
            cbMktg = "false";
        }
    }
    else {
        cbMktg = sceltaRegMktg;
    }
    if (sceltaRegProf == null || sceltaRegProf == undefined || sceltaRegProf == '') {
        if (ConsensoProf == "true") {
            cbProf = "true";
        }
        else {
            cbProf = "false";
        }
    }
    else {
        cbProf = sceltaRegProf;
    }

    var params = {
        ConsensoMark: cbMktg,
        ConsensoProf: cbProf,
        ConsensoBase: ConsensoBase,
        ConsensoServizio: ConsensoServizio,
    };

    $.ajax({
        url: '/Account/UpdateGestioneConsensi',
        type: 'POST',
        data: params,
        success: function (result) {
            try {
                if (result.esito == Costanti.ESITO_OK) {
                    mainController.NotifyMessageTimed(result.responseText, result.NotifyColor, 4500);
                    setTimeout(function () {
                        window.location.href = result.ReturnUrl;
                    }, 2500);
                }
                else {
                    mainController.NotifyMessageTimed(result.responseText, result.NotifyColor, 4500);
                }
            }
            catch (err) {
                mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), Costanti.NOTIFY_COLOR_ERROR);
            }
        },
        error: function (xhr, status, error) {
            mainController.NotifyMessage(mainController.GetLabel('lErroreGenerico'), Costanti.NOTIFY_COLOR_ERROR);
            waitingBS.Hide();
        }
    });
    //}
    //else {
    //    mainController.NotifyMessageTimed(mainController.GetLabel('lErroreServizio'), Costanti.NOTIFY_COLOR_ERROR, 4500);
    //}
}

/**
 * Funzione che aggiunge il movimento di aumento e riduzione dell'header durante lo scroll.
 * @param {any} pixels il numero di pixel che si devono togliere dall'header.
 */
function AggiungiScrollPerHeader(pixels) {
    const logo = document.getElementById('SiteLogo');
    let lastScrollTop = 0;

    $(document).on('scroll', () => {

        let scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop && isElementInViewport($('footer')[0]) == false) {
            // Stai scorrendo verso il basso
            document.getElementsByClassName("fixed-top")[0].style.top = pixels;
            $('main').css('margin-top', '10rem');
            $('header .nav-cat').addClass('d-none');
        } else {
            // Stai scorrendo verso l'alto
            $('main').removeAttr('style');
            $('header .nav-cat').removeClass('d-none');
            document.getElementsByClassName("fixed-top")[0].style.top = "0";

            logo.style.width = "100%"; // Ripristina la dimensione originale del logo
        }
        // Aggiorna l'ultimo valore di scroll
        lastScrollTop = scrollTop;
    });
}

function isElementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
}


function InvitaAccount(accountID, userName, email) {
    try {
        var p = {};
        p.Login = userName;
        p.Email = email;
        p.IdAccount = accountID;

        mainController.CallServiceAsync("/Account/InvitaAccount", p)
            .then(function (r) {
                waitingBS.Hide();
                if (r.esito == "ok") {
                    mainController.NotifyMessage(r.responseText, r.NotifyColor);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
            })
            .catch(function (error) {
                console.log(error);
                waitingBS.Hide();
                mainController.NotifyMessage("ERROR", "danger");
            });
    }
    catch (error) {
        console.log(error);
    }
}

function GestioneButton(testoInvita, testoSalva) {
    var grid = $('#gridGesticeAccount').dxDataGrid('instance');
    var rowIndex = grid.getVisibleRows().findIndex(r => r.isEditing);
    var rowIndexInsert = grid.getVisibleRows().findIndex(r => r.isNewRow);

    var rowDati = grid.getVisibleRows()[rowIndex].data;
    var ACCO_PrimoAccesso = rowDati.ACCO_PrimoAccesso;

    if (rowIndex == 0 && rowIndexInsert == 0) {
        return testoInvita;
    }
    else if (ACCO_PrimoAccesso == true) {
        return testoInvita;
    }
    else {
        return testoSalva;
    }
}

function GestioneTitle(testoNuovo, testoModifica) {
    var grid = $('#gridGesticeAccount').dxDataGrid('instance');
    var rowIndex = grid.getVisibleRows().findIndex(r => r.isEditing);
    var rowIndexInsert = grid.getVisibleRows().findIndex(r => r.isNewRow);

    if (rowIndex == 0 && rowIndexInsert == 0) {
        return testoNuovo;
    }
    else {
        return testoModifica;
    }
}

function gridGesticeAccount_editPopup_OnShowing(e) {
    try {

        var popup = $('#gridGesticeAccount_editPopup').dxPopup('instance');

        if (popup) {
            popup.option('toolbarItems', null);
        }

    } catch (ex) {
        console.log(ex);
    }
}

function ChangeReimpostaPassword(VisibilitaConsensiServizio,
    VisibilitaConsensiPrivacy,
    VisibilitaConsensiNewsLetter,
    VisibilitaConsensiProfilazione,
    ConsensoBase,
    ConsensoServizio,
    ConsensoNewsletter,
    ConsensoProfilazione,
    IdSito,
    Email,
    Username,
    IdUser,
    EmailVerificata) {
    var password = $('#rec-password');
    var cpassword = $('#rec-cpassword');
    var chkpassword = $('#chkpassword');

    var AccettaConsensoServizio = $('#regsrv1');
    var NonAccettaConsensoServizio = $('#regsrv2');
    var errorServizio = $('#lErroreSrv');

    var sceltaNewsletter = $('#sceltaRegMktg').val();
    var erroreNewsletter = $('#lErroreMktg');

    var sceltaProfilazione = $('#sceltaRegProf').val();
    var erroreProfilazione = $('#lErroreProf');

    var result = true;

        if (VisibilitaConsensiServizio == true) {
            if (AccettaConsensoServizio.prop('checked') == true) {
                errorServizio.removeClass('is-invalid');
                ConsensoServizio = true;
            }
            else if (NonAccettaConsensoServizio.prop('checked') == true) {
                ConsensoServizio = false;
            }
            else {
                errorServizio.addClass('is-invalid');
                result = false;
            }
        }

        if (VisibilitaConsensiPrivacy == true) {
            ConsensoBase = true;
        }

        if (VisibilitaConsensiNewsLetter == true) {
            if (sceltaNewsletter == null || sceltaNewsletter == undefined || sceltaNewsletter == '') {
                erroreNewsletter.addClass('is-invalid');
                result = false;
            }
            else {
                erroreNewsletter.removeClass('is-invalid');
                ConsensoNewsletter = sceltaNewsletter;
            }
        }

        if (VisibilitaConsensiProfilazione == true) {
            if (sceltaProfilazione == null || sceltaProfilazione == undefined || sceltaProfilazione == '') {
                erroreProfilazione.addClass('is-invalid');
                result = false;
            }
            else {
                erroreProfilazione.removeClass('is-invalid');
                ConsensoProfilazione = sceltaProfilazione;
            }
        }

    if (result == true) {
        if (((NonAccettaConsensoServizio.length > 0 && NonAccettaConsensoServizio.prop('checked') == false) || NonAccettaConsensoServizio.length == 0)
            && ((AccettaConsensoServizio.length > 0 && AccettaConsensoServizio.prop('checked') == true || AccettaConsensoServizio.length == 0))) {

            if (CheckPassword(password, cpassword, chkpassword, IdSito, true) == true) {

                var params = {
                    password: password.val(),
                    email: Email,
                    Username: Username,
                    IdUser: IdUser,
                    EmailVerificata: EmailVerificata,
                    CustomerRegistrationViewModel: {
                        ConsensoBase: ConsensoBase,
                        ConsensoServizio: ConsensoServizio,
                        ConsensoProfilazione: ConsensoProfilazione,
                        ConsensoNewsletter: ConsensoNewsletter
                    }
                };

                waitingBS.Show();

                mainController.CallServiceAsync('/Account/ReimpostaPassword', params)
                    .then(risp => {
                        if (risp.esito == Costanti.ESITO_OK) {
                            mainController.NotifyMessage(risp.responseText, risp.NotifyColor);

                            setTimeout(() => {
                                window.location.href = risp.ReturnUrl;
                            }, 3000);
                        }
                        else {
                            mainController.NotifyMessage(risp.responseText, risp.NotifyColor);
                            waitingBS.Hide();
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        waitingBS.Hide();
                    });
            }
        }
    }

    return false;
}

function VerificaFormLavora() {
    var formstate = true;

    if (!mainController.CheckEmail($("#fcEmail").val())) {
        $("#fcEmail").addClass('is-invalid');
        formstate = false;
    }

    $("form#flavoraconnoi :input").each(function () {
        $(this).removeClass('is-invalid');
        if ($(this).attr('required') && ($(this)[0].disabled == false || !$(this).attr('disabled'))) {
            if (!$(this).val()?.trim()) {
                $(this).addClass('is-invalid');
                formstate = false;
            }
        }
        else {
            $(this).removeClass('is-invalid');
        }
    });

    try {
        const recaptcha_box_checked = (grecaptcha.getResponse()) ? true : false;

        if (recaptcha_box_checked == false) {
            formstate = false;
            mainController.NotifyMessage(mainController.GetLabel('lErroreCaptchaVuoto'), 'error');
        }
    }
    catch (error) {
        console.log(error);
        formstate = false;
    }
    return formstate;
}

/**
 * 
 * @param {any} idElementToBlock
 * @param {any} divElementTooltip
 * @param {any} testo
 * @param {any} direction
 * @param {any} type si aspetta i soliti valori di bootstrap: 'danger' - 'warning' - 'info'
 */
function SelezionaAzienda(idElementToBlock, divElementTooltip, testo, direction, type) {
    try {

        var msg = mainController.GetLabel('lTooltipSelezionaAzienda');
        var dir = 'right';
        var customClass = 'danger-tooltip';

        if (testo && testo?.trim().length > 0) {
            msg = testo;
        }

        if (direction && direction?.trim().length > 0) {
            dir = direction;
        }

        if (type && type?.trim().length > 0) {
            switch (type) {

                case 'danger':
                    customClass = 'danger-tooltip';
                    break;
                case 'warning':
                    customClass = 'warning-tooltip';
                    break;
                case 'info':
                    customClass = 'help-tooltip';
                    break;
                default:
                    customClass = 'danger-tooltip';
                    break;
            }
        }

        if (idElementToBlock && idElementToBlock.length > 0) {

            var elem = $('#' + idElementToBlock);
            if (elem && elem.length > 0) {
                elem.addClass("disabledfn");
            }
        }

        if (divElementTooltip && divElementTooltip.length > 0) {

            var divElem = $('#' + divElementTooltip);

            divElem.attr('data-bs-toggle', 'tooltip');
            divElem.attr('data-bs-title', mainController.decodeHTMLEntity(msg));
            divElem.attr('data-bs-custom-class', customClass);
            divElem.attr('data-bs-placement', dir);

            if (divElem && elem.length > 0) {

                divElem.tooltip('show');
                setTimeout(() => {
                    divElem.tooltip('hide');
                }, 4000);
            }
        }
        else {
            var ddlAziende = $('#selazienda');

            ddlAziende.attr('data-bs-toggle', 'tooltip');
            ddlAziende.attr('data-bs-title', mainController.decodeHTMLEntity(msg));
            ddlAziende.attr('data-bs-custom-class', 'danger-tooltip');
            ddlAziende.attr('data-bs-placement', 'right');

            ddlAziende.tooltip('show');
            setTimeout(() => {
                ddlAziende.tooltip('hide');
            }, 4000);
        }

        InizializzaTooltipBootstrap();

    } catch (ex) {
        console.error(ex);
    }
}

function ControllaErroreTotaliCarrello() {
    try {
        var queryString = undefined;
        queryString = mainController.getUrlVars()["error"];

        if (queryString) {
            var messaggio = undefined;
            switch (queryString) {
                case 'TotaliOrdine':
                    messaggio = 'lTotaleOrdineErrato';
                    break;
                case 'CreazioneOrdine':
                    messaggio = 'lErroreCreazioneOrdine';
                    break;
                default:
                    breaK;
            }

            if (messaggio) {
                mainController.NotifyMessageTimed(mainController.GetLabel(messaggio), Costanti.NOTIFY_COLOR_ERROR, 10000);

                //pulisco l'url
                var urlObj = new URL(window.location.href);
                urlObj.search = '';
                history.replaceState(null, '', urlObj.toString());
            }
            else {
                console.log('Cannot find message from query string \'error\'');
            }
        }
    }
    catch (error) {
        console.log(error);
    }
}